webpackJsonptesseract([1],{

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContainerDefault */
/* unused harmony export Container */
/* unused harmony export WeatherDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_context_provider__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wiretie__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_location_widget__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__weather__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__weather_compact__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__error_msg__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__spinner__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(739);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var ContainerDefault = function (_Component) {
	_inherits(ContainerDefault, _Component);

	function ContainerDefault() {
		var _temp, _this, _ret;

		_classCallCheck(this, ContainerDefault);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			currentUnit: _this.props.unit || 'F'
		}, _this.alertURL = function (location, useWeatherChannel, config) {
			var country = __WEBPACK_IMPORTED_MODULE_13_dlv___default()(location, 'country_iso_code'),
			    geoName = __WEBPACK_IMPORTED_MODULE_13_dlv___default()(location, 'geoname_id'),
			    postalCode = void 0,
			    url = void 0;

			// Handle the value coming in an array or as a string
			if (location.postal_code) {
				if (Array.isArray(location.postal_code)) {
					postalCode = location.postal_code[0];
				} else {
					postalCode = location.postal_code;
				}
			}

			// We need both the country and postalCode if we are using the weather channel
			if (useWeatherChannel) {
				if (country && postalCode) {
					url = config.weatherAlertWeatherURL + '/' + postalCode + config.weatherAlertWeatherPath + country;
				}
			}
			// We can power the portal alert page with just a GeoID value, or
			// both the country and postal code values together.
			else if (geoName || country && postalCode) {
					url = config.weatherAlertNativeURL + '/' + (geoName || 0) + '/' + (country || 0) + '/' + (postalCode || 0);
				}

			return url;
		}, _this.updateTempUnit = function (unit) {
			if (!unit || typeof unit !== 'string') {
				return;
			}

			if (!_this.state.currentUnit || _this.state.currentUnit.toUpperCase() !== unit.toUpperCase()) {
				_this.props.setUnit && _this.props.setUnit(unit.toUpperCase());
				_this.setState({ currentUnit: unit.toUpperCase() });
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
  * Determine where we need to link off to, and craft the appropriate URL
  *
  * @param {Object}  location - Holds data points about a location
  * @param {string|undefined}  location.country_iso_code
  * @param {string|undefined}  location.geoname_id
  * @param {string|Array|undefined}  location.postal_code
  * @param {boolean} useWeatherChannel - Value set by Gen4 that determines whether we link to the WC or the Portal
  * @param {Object}  config - Configuration constants from @withConfig
  * @param {string}  config.weatherAlertWeatherURL - Url to Weather Channels's alert route
  * @param {string}  config.weatherAlertWeatherPath - Path values needed to properly link off to Weather Channel's alert page
  * @param {string}  config.weatherAlertNativeURL - Base URL that points to the Portal's weather component/vertical
  * @return {string|undefined}
  */


	/**
  * Update user's temperature scale preferences locally, and attempt to call
  * a function named 'setUnits' if it exists on our props object. This props
  * function currently saves this information to Local Storage and should flow down
  * back to this component through it's model subscription.
  *
  * @param {string|undefined} unit - Temperature unit to set in Local Storage
  */


	ContainerDefault.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.unit && this.props.unit !== nextProps.unit) {
			this.setState({ currentUnit: nextProps.unit.toUpperCase() });
		}
	};

	ContainerDefault.prototype.render = function render(_ref, _ref2) {
		var clientId = _ref.clientId,
		    location = _ref.location,
		    locationServiceOrigin = _ref.locationServiceOrigin,
		    notifyCurrentLocationChange = _ref.notifyCurrentLocationChange,
		    conditions = _ref.conditions,
		    alerts = _ref.alerts,
		    forecast = _ref.forecast,
		    unit = _ref.unit,
		    config = _ref.weatherWidgetConfig,
		    firstLoad = _ref.firstLoad,
		    pending = _ref.pending,
		    rejected = _ref.rejected,
		    localeWeatherUrl = _ref.localeWeatherUrl,
		    localeWeatherRadarUrl = _ref.localeWeatherRadarUrl,
		    _ref$compact = _ref.compact,
		    compact = _ref$compact === undefined ? false : _ref$compact,
		    showRadarFullForecastLink = _ref.showRadarFullForecastLink,
		    showAlerts = _ref.showAlerts;
		var currentUnit = _ref2.currentUnit;

		var content = void 0,
		    header = void 0;

		if (pending || firstLoad) {
			content = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__spinner__["a" /* default */], null);
		} else if (rejected && rejected.forecast && rejected.conditions || !location || !location.latitude || !location.longitude || !forecast) {
			content = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__error_msg__["a" /* default */], null);
		} else {
			var weatherAlertUrl = this.alertURL(location, config.useWeatherChannel, config.alertConfig);
			var weatherLink = void 0;
			if (typeof localeWeatherUrl !== 'undefined') {
				config.weatherUrl = localeWeatherUrl;
				config.radarFullForecastWeatherURL = localeWeatherUrl;
				weatherLink = localeWeatherUrl;
				config.useWeatherChannel = true;
				weatherAlertUrl = localeWeatherUrl;
			} else {
				weatherLink = config.weatherLink + '/?' + config.trackingParams + '_' + clientId;
			}
			content = compact ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__weather_compact__["a" /* default */], { conditions: conditions, currentUnit: currentUnit, config: config, location: location, changeUnit: this.updateTempUnit }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__weather__["a" /* default */], { conditions: conditions, currentUnit: currentUnit, config: config, forecast: forecast, weatherLink: weatherLink,
				trackingParams: config.trackingParams, clientId: clientId, alerts: alerts, weatherAlertUrl: weatherAlertUrl, changeUnit: this.updateTempUnit,
				showRadarFullForecastLink: showRadarFullForecastLink, showAlerts: showAlerts
			});
		}
		header = compact ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__cube_location_widget__["a" /* default */], { style: 'display: none', onChange: notifyCurrentLocationChange, locationServiceOrigin: locationServiceOrigin }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["h" /* HeaderV2 */],
			{ 'class': __WEBPACK_IMPORTED_MODULE_11__style___default.a.header, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */],
					{ id: 'weather' },
					'Weather'
				) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__cube_location_widget__["a" /* default */], {
				containerClass: __WEBPACK_IMPORTED_MODULE_11__style___default.a.location,
				popoverClass: __WEBPACK_IMPORTED_MODULE_11__style___default.a.popover,
				onChange: notifyCurrentLocationChange,
				anchor: 'right',
				locationServiceOrigin: locationServiceOrigin
			})
		);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_11__style___default.a.weather) },
			header,
			content
		);
	};

	return ContainerDefault;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Container = Object(__WEBPACK_IMPORTED_MODULE_2_wiretie__["a" /* default */])('weather', function (_ref3) {
	var _ref3$location = _ref3.location,
	    location = _ref3$location === undefined ? {} : _ref3$location;
	return location.latitude && location.longitude ? {
		conditions: ['fetchCurrentConditions', location.latitude, location.longitude],
		alerts: ['fetchAlerts', { latitude: location.latitude, longitude: location.longitude }],
		forecast: ['fetchDailyForecast', location.latitude, location.longitude],
		unit: 'getTemperatureScale'
	} : {};
}, function (weather) {
	return {
		setUnit: weather.setTemperatureScale
	};
})(ContainerDefault);

var WeatherDefault = function (_Component2) {
	_inherits(WeatherDefault, _Component2);

	function WeatherDefault(props, context) {
		_classCallCheck(this, WeatherDefault);

		var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props, context));

		_this2.state = {
			location: {},
			firstLoad: true // @TODO: Can this be fixed in location-widget|model?
		};

		_this2.notifyCurrentLocationChange = function (locationObject) {
			var data = _extends({}, locationObject, {
				postal_code: [].concat(locationObject.postal_code)[0]
			});

			if (!data.postal_code && _this2.state.firstLoad) {
				_this2.setState({ firstLoad: false });
			} else {
				_this2.setState({ location: data, firstLoad: false });
			}
		};

		var locationServiceOrigin = __WEBPACK_IMPORTED_MODULE_13_dlv___default()(props, 'locationServiceOrigin'),
		    weatherServiceOrigin = __WEBPACK_IMPORTED_MODULE_13_dlv___default()(props, 'weatherServiceOrigin'),
		    config = {};

		if (locationServiceOrigin) {
			config.locationServiceOrigin = locationServiceOrigin;
		}

		if (weatherServiceOrigin) {
			config.weatherServiceOrigin = weatherServiceOrigin;
		}

		_this2.weatherProvider = new __WEBPACK_IMPORTED_MODULE_3__model__["a" /* WeatherModel */](config);
		return _this2;
	}

	/**
  * Handle a new location being chosen by the location widget.
  *
  * There is a special case here for the first load or first time this
  * handler is called, as it's often first given an empty object by the
  * embedded location-widget/model. In this instance we do nothing but
  * set our 'firstLoad' state to false which will allow any successive
  * calls to this function with a bad {locationObject} value will be
  * set into state and the error message handled by the <Container />.
  *
  * @param {Object} locationObject
  * @param {string|Array|undefined} locationObject.postal_code
  */


	WeatherDefault.prototype.render = function render(_ref4, _ref5) {
		var location = _ref5.location,
		    firstLoad = _ref5.firstLoad;

		var locationServiceOrigin = _ref4.locationServiceOrigin,
		    weatherWidgetConfig = _ref4.weatherWidgetConfig,
		    props = _objectWithoutProperties(_ref4, ['locationServiceOrigin', 'weatherWidgetConfig']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__os_context_provider__["a" /* default */],
				{ weather: this.weatherProvider },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Container, _extends({}, props, {
					notifyCurrentLocationChange: this.notifyCurrentLocationChange,
					locationServiceOrigin: locationServiceOrigin,
					weatherWidgetConfig: weatherWidgetConfig,
					location: location,
					firstLoad: firstLoad
				}))
			)
		);
	};

	return WeatherDefault;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */])(['locationServiceOrigin', 'weatherServiceOrigin', 'weatherWidgetConfig', 'clientId', 'showAlerts'])(WeatherDefault));

/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WeatherModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_helpers_index__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_dbee_client__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_is_date_today__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__ = __webpack_require__(1128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









// Hour, in military, for the cutoff of showing "today" in the weather
// Used to remove today's weather and leave only tonight's weather after a
// certain period of time.
var TODAY_CUTTOFF = 18;

/**
 * This contains logic necessary to interact with the weather service, as well as
 * sanitizing the response for use on the front end. It is exported as a class in
 * order to facilitate testing, even though in general each function could be
 * exported by itself as it has no state dependencies.
 *
 */
var WeatherModel = function () {
	function WeatherModel() {
		var _this = this;

		var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		_classCallCheck(this, WeatherModel);

		this._getLocalTempUnit = __WEBPACK_IMPORTED_MODULE_3__lib_dbee_client__["a" /* default */].get;
		this._setLocalTempUnit = __WEBPACK_IMPORTED_MODULE_3__lib_dbee_client__["a" /* default */].set;

		this.setTemperatureScale = function (tempUnit) {
			_this._setLocalTempUnit(tempUnit);
		};

		this.getTemperatureScale = function () {
			var _getLocalTempUnit = _this._getLocalTempUnit(),
			    tempUnit = _getLocalTempUnit.tempUnit;

			return tempUnit;
		};

		this.fetchLocationDataFromService = function (geoId) {
			var queryString = _this.locationServiceOrigin.replace(/\/$/, '') + ('/geonameid/' + geoId + '/');
			return fetch(queryString).then(function (r) {
				return r.json();
			});
		};

		this.fetchUsZipFromGeo = function (geoId) {
			return _this.fetchLocationDataFromService(geoId).then(function (body) {
				var entry = body.documents[0];

				return entry.geoname_id;
			});
		};

		this.fetchLocationFromGeo = function (geoId) {
			return _this.fetchLocationDataFromService(geoId).then(function (entry) {
				if (typeof entry !== 'undefined') {
					return {
						latitude: entry.latitude,
						longitude: entry.longitude,
						city: entry.city_name,
						state: entry.subdivision_1_iso_code,
						country: entry.country_iso_code
					};
				}

				return null;
			});
		};

		this.fetchTimeSeries = function (type, latitude, longitude) {
			var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '640x480';
			return __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["f" /* fetchTimeSeries */](type, latitude, longitude, size);
		};

		this.fetchAlerts = function (_ref) {
			var latitude = _ref.latitude,
			    longitude = _ref.longitude,
			    city = _ref.city,
			    state = _ref.state,
			    country = _ref.country;
			return __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["b" /* fetchAlerts */](latitude, longitude).then(function (data) {
				if (data) {
					data.location = { city: city, state: state, country: country, latitude: latitude, longitude: longitude };
					return data;
				}
				console.error('No data given');
				return [];
			}).then(_this._sanitizeAlerts).catch(function (e) {
				return null;
			});
		};

		this._fetchDetailedAlerts = function (key) {
			return __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["a" /* fetchAlertDetails */](key).then(function (r) {
				return r.alerts_details || [];
			});
		};

		this._sanitizeAlerts = function (data) {
			var alerts = data.alerts;
			if (!alerts || !alerts.length) return {};

			var description = void 0,
			    color = void 0;

			// Set alerts based on order returned, with the first being
			// the highest severity and tally advisory types
			alerts.map(function (a, idx) {
				if (alerts[idx].description) {
					// Build description or Alert + Advisory objects
					description = alerts[idx].description;
					color = alerts[idx].color;
				}
			});

			return {
				description: description,
				color: color,
				totalAlerts: alerts.length,
				alerts: alerts,
				location: data.location
			};
		};

		this.fetchAlertPage = function (geoId) {
			return _this.fetchLocationFromGeo(geoId).then(_this.fetchAlerts).then(_this._createAlertObjects).catch(function (e) {
				console.error(e);
				return [];
			});
		};

		this.loadAlertsDetailsPage = function (geoId) {
			return _this.fetchAlertPage(geoId);
		};

		this._createAlertObjects = function (data) {
			var alerts = data.alerts,
			    location = data.location;
			var _ref2 = [alerts.map(function (a) {
				return a.detail_key;
			}).join(','), {}],
			    detailKey = _ref2[0],
			    alertObjects = _ref2[1];

			if (!detailKey) {
				var noDetailKeyFoundError = new Error('No detail_key property was found');
				noDetailKeyFoundError.code = __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* Errors */].NO_DETAIL_KEY_FOUND;
				throw noDetailKeyFoundError;
			}

			for (var i = 0; i < alerts.length; i++) {
				alertObjects[alerts[i].detail_key] = {
					headlineText: alerts[i].description,
					color: alerts[i].color,
					source: alerts[i].source,
					expireTimeGmt: alerts[i].expiration,
					key: alerts[i].detail_key,
					detailedDesc: _this._formatDetailedAlertDescription(alerts[i].detail_description)

				};
			}

			return { detailKey: detailKey, alertObjects: alertObjects, location: location };
		};

		this.fetchHourlyForecast = __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["e" /* fetchHourlyForecast */];

		this.getDailyForecastData = function (latitude, longitude) {
			return _this.fetchHourlyForecast(latitude, longitude).then(function (data) {
				return (data || []).map(function (hourlyForecast) {
					return _this._sanitizeHourlyForecast(hourlyForecast);
				});
			});
		};

		this._sanitizeHourlyForecast = function (f) {
			var conditionDesc = f.description,
			    precipitation = (f.precip_prob || 0) + '%',
			    temp = (f.imperial.temp || 0) + '\xB0',
			    tempCels = (Math.round(f.metric.temp) || 0) + '\xB0',
			    timestamp = f.valid_until * 1000,
			    windSpeed = _this.createWindObject(f.wind_direction, Math.round(f.imperial.wind_speed)),
			    feels = (f.imperial.temp_feel || 0) + '\xB0',
			    feelsCels = (Math.round(f.metric.temp_feel) || 0) + '\xB0',
			    humidity = (f.humidity || 0) + '%',
			    iconCode = f.icon || '',
			    _formatTimestamp = _this._formatTimestamp(timestamp),
			    dayAndMonth = _formatTimestamp.dayAndMonth,
			    formattedMobileTime = _formatTimestamp.formattedMobileTime,
			    formattedDesktopTime = _formatTimestamp.formattedDesktopTime;


			return {
				conditionDesc: conditionDesc,
				dayAndMonth: dayAndMonth,
				feels: feels,
				feelsCels: feelsCels,
				formattedDesktopTime: formattedDesktopTime,
				formattedMobileTime: formattedMobileTime,
				humidity: humidity,
				iconCode: iconCode,
				precipitation: precipitation,
				temp: temp,
				tempCels: tempCels,
				timestamp: timestamp,
				windSpeed: windSpeed
			};
		};

		this._formatTimestamp = function (timestamp) {
			var start = new Date(timestamp);
			var dayAndMonth = start.getMonth() + 1 + '/' + start.getDate();
			var amPm = start.getHours() >= __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */] ? 'PM' : 'AM';
			var formattedMobileTime = (start.getHours() % __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */] || __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */]) + amPm;
			var formattedDesktopTime = '' + (start.getHours() % __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */] || __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */]) + (':00' + amPm);
			return { dayAndMonth: dayAndMonth, formattedMobileTime: formattedMobileTime, formattedDesktopTime: formattedDesktopTime };
		};

		this.fetchCurrentConditions = function (latitude, longitude) {
			var dayCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DEFAULT_FORECAST_DAYS */];
			return Promise.all([__WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["d" /* fetchDailyForecast */](latitude, longitude, dayCount), __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["c" /* fetchCurrentConditions */](latitude, longitude)]).then(function (_ref3) {
				var forecastData = _ref3[0],
				    current = _ref3[1];

				var forecast = forecastData.forecasts[0];
				return _this._sanitizeCurrentConditions(forecast, current);
			});
		};

		this._sanitizeCurrentConditions = function (forecast, current) {
			var currentTemp = current.imperial.temp;
			var currentTempCels = Math.round(current.metric.temp);
			var conditions = Object(__WEBPACK_IMPORTED_MODULE_2__lib_helpers_index__["c" /* replaceFwdSlash */])(current.description);
			var conditionDescription = current.description;
			var sunrise = forecast.sunrise;
			var sunset = forecast.sunset;
			var weatherIconCode = current.icon;
			var iconCodeNumeric = current.icon || '';

			var highTemp = forecast.imperial.temp_max || forecast.night && forecast.night.imperial.temp_high || 0;
			var highTempCels = Math.round(forecast.metric.temp_max) || forecast.night && Math.round(forecast.night.metric.temp_high) || 0;
			var lowTemp = forecast.imperial.temp_min || forecast.night && forecast.night.imperial.temp_min || 0;
			var lowTempCels = Math.round(forecast.metric.temp_min) || forecast.night && Math.round(forecast.night.metric.temp_min) || 0;

			var dayOrNight = Array.isArray(forecast.day) ? forecast.night : forecast.day;

			var precip = dayOrNight.precip_prob || 0;

			return {
				currentTemp: currentTemp,
				currentTempCels: currentTempCels,
				conditions: conditions,
				conditionDescription: conditionDescription,
				highTemp: highTemp,
				highTempCels: highTempCels,
				lowTemp: lowTemp,
				lowTempCels: lowTempCels,
				sunrise: sunrise,
				sunset: sunset,
				weatherIconCode: weatherIconCode,
				iconCodeNumeric: iconCodeNumeric,
				precip: precip
			};
		};

		this.fetchFeelsLike = function (latitude, longitude) {
			return _this.fetchHourlyForecast(latitude, longitude).then(function (d) {
				return _this._sanitizeFeelsLike(d.slice(0, 1).pop());
			});
		};

		this._sanitizeFeelsLike = function (forecast) {
			var asOfTime = new Date();
			var feelsLike = forecast.imperial.temp_feel || 0;
			var feelsLikeCels = Math.round(forecast.metric.temp_feel) || 0;
			var uvIndex = forecast.uv_index || 0;
			var wind = _this.createWindObject(forecast.wind_direction, Math.round(forecast.imperial.wind_speed));
			var humidity = forecast.humidity || 0;
			var dew = forecast.imperial.dew_point || 0;
			var dewCels = Math.round(forecast.metric.dew_point) || 0;
			var pressure = (forecast.pressure || 0) + ' in';
			var visibility = forecast.imperial.vis + ' mi';
			var pop = (forecast.precip_prob || 0) + '%';

			return {
				asOfTime: asOfTime,
				feelsLike: feelsLike,
				feelsLikeCels: feelsLikeCels,
				uvIndex: uvIndex,
				wind: wind,
				humidity: humidity,
				dew: dew,
				dewCels: dewCels,
				pressure: pressure,
				visibility: visibility,
				pop: pop
			};
		};

		this.fetchLookAheadTiles = function (latitude, longitude) {
			var dayCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DEFAULT_FORECAST_DAYS */];
			var tileCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;
			return __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["d" /* fetchDailyForecast */](latitude, longitude, dayCount).then(function (data) {
				return _this._sanitizeLookingAhead(data, dayCount, tileCount);
			});
		};

		this._sanitizeLookingAhead = function (apiResponse) {
			var dayCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
			var tileCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

			if (!apiResponse || !apiResponse.forecasts || !apiResponse.forecasts.length) {
				return [];
			}

			return apiResponse.forecasts.slice(0, dayCount).map(function (f, i) {
				return _this._buildLookAheadTiles(_extends({ idx: i }, f));
			}).reduce(function (a, b) {
				return a.concat(b);
			}).slice(0, tileCount);
		};

		this._buildLookAheadTiles = function (forecast) {
			var tiles = [];

			// For the first entry/day only, we make two tiles out of one forecast
			if (forecast.idx === 0) {
				var date = new Date();

				// For some reason, if we're missing the day value, it's also an array because why not!
				// (It's probably something to do with Golang json parsing defaults)
				// If it is past 6pm, exclude day from the tiles, allowing us to show an extra day
				if (date.getHours() < TODAY_CUTTOFF && !Array.isArray(forecast.day) && Object.keys(forecast.day).length > 0) {
					tiles = tiles.concat(_this._buildTile(forecast, true));
				}
				tiles = tiles.concat(_this._buildTile(forecast));
			} else {
				// We'll always have a day object here, and should base most stuff off that
				tiles = tiles.concat(_this._buildTile(forecast));
			}

			return tiles;
		};

		this._buildTile = function (forecast, isTodayTile) {
			var _ref4 = [forecast.day, forecast.night],
			    day = _ref4[0],
			    night = _ref4[1];


			var isFirstTile = forecast.idx === 0;
			var isTonightTile = isFirstTile && !isTodayTile;

			// low and high now act as keys for il8n
			var highLowLabel = { low: isTonightTile, high: !isTonightTile };
			var highLowValue = isTonightTile ? forecast.imperial.temp_min : forecast.imperial.temp_max;
			var highLowValueCels = isTonightTile ? Math.round(forecast.metric.temp_min) : Math.round(forecast.metric.temp_max);

			var desc = isTonightTile ? night.phrase_long : day.phrase_long;
			var descCels = desc && _this._addDegreeSymToString(_this._convertDescToCelsius(desc));
			desc = desc && _this._addDegreeSymToString(desc);
			var simpleDesc = isTonightTile ? night.phrase_short : day.phrase_short;

			var title = void 0;
			if (isFirstTile) {
				// Today and tonight now act as keys for il8n
				title = { today: isTodayTile, tonight: !isTodayTile };
			} else {
				title = { dow: forecast.day_of_week.toLowerCase() };
			}

			var precipChance = isTonightTile ? night.precip_prob || 0 : day.precip_prob || 0;

			var windSpeed = isTonightTile ? _this.createWindObject(night.wind_direction, Math.round(night.imperial.wind_speed)) : _this.createWindObject(day.wind_direction, Math.round(day.imperial.wind_speed));
			var uvIndex = isTonightTile ? '' + (night.uv_index || 0) : '' + (day.uv_index || 0);

			var sunrise = Object(__WEBPACK_IMPORTED_MODULE_2__lib_helpers_index__["b" /* handleSunFormat */])(forecast.sunrise) + _this._getAmPm(forecast.sunrise);
			var sunset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_helpers_index__["b" /* handleSunFormat */])(forecast.sunset) + _this._getAmPm(forecast.sunset);

			var humidity = isTonightTile ? night.humidity || 0 : day.humidity || 0;

			var dailyWeatherIconCode = forecast.day.icon || '';
			var nightlyWeatherIconCode = forecast.night.icon || '';
			var weatherIconCode = dailyWeatherIconCode || nightlyWeatherIconCode;

			return {
				highLowLabel: highLowLabel,
				highLowValue: highLowValue,
				highLowValueCels: highLowValueCels,
				desc: desc,
				descCels: descCels,
				simpleDesc: simpleDesc,
				title: title,
				precipChance: precipChance,
				windSpeed: windSpeed,
				uvIndex: uvIndex,
				sunrise: sunrise,
				sunset: sunset,
				humidity: humidity,
				weatherIconCode: weatherIconCode
			};
		};

		this._getAmPm = function (dateStr) {
			// Sample dateStr value: 2017-02-10T17:32:51-0800
			if (dateStr) {
				var a = dateStr.replace(/\D/g, ' ').split(' ');
				var amPm = ~~a[3] >= __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */] ? 'pm' : 'am';
				return '' + amPm;
			}
		};

		this._formatLookAheadTimestamp = function (date) {
			var _ref5 = [date.getHours() % __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */] || __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */], date.getMinutes()],
			    hour = _ref5[0],
			    minutes = _ref5[1];

			var amPm = date.getHours() >= __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NOON */] ? 'pm' : 'am';
			var minuteDisplay = minutes > 9 ? minutes : '' + ('0' + minutes);
			return hour + ':' + minuteDisplay + ' ' + amPm;
		};

		this.fetchDailyForecast = function (latitude, longitude) {
			var dayCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DEFAULT_FORECAST_DAYS */];
			return __WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["d" /* fetchDailyForecast */](latitude, longitude, dayCount).then(function (data) {
				return _this._sanitizeDailyForecast(data, dayCount);
			});
		};

		this._sanitizeDailyForecast = function (apiResponse) {
			var dayCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DEFAULT_FORECAST_DAYS */];

			if (!apiResponse || !apiResponse.forecasts || !apiResponse.forecasts.length) {
				return [];
			}

			return apiResponse.forecasts.slice(0, dayCount).map(function (f, i) {
				return _this._buildForecast(f, i);
			});
		};

		this._addDegreeSymToString = function (str) {
			if (!str.match(/\d(F|C)/g)) return str;
			str.match(/\d(F|C)/g).map(function (tempRaw) {
				var tempFormatted = ('' + tempRaw).split('').join('° ');
				str = str.replace(tempRaw, tempFormatted);
			});
			return str;
		};

		this._convertDescToCelsius = function (desc) {
			var regEx = /\d{1,3}F/g,
			    formattedDesc = desc;


			(desc.match(regEx) || []).map(function (fTemp) {
				formattedDesc = formattedDesc.replace(fTemp, Object(__WEBPACK_IMPORTED_MODULE_2__lib_helpers_index__["a" /* fahrenheitToCelsius */])(fTemp.slice(0, fTemp.length - 1)) + 'C');
			});

			return formattedDesc;
		};

		this._buildForecast = function (forecast, idx) {
			var validDate = new Date(Number(forecast.valid_until) * 1000);
			var hasDay = Object.keys(forecast.day).length > 0;

			//For first day, check to see if past cutoff to show day breakdown
			if (hasDay && idx === 0 && new Date().getHours() >= TODAY_CUTTOFF) {
				hasDay = false;
			}

			var dailyHigh = forecast.day.imperial.temp_high || 0;
			var dailyHighCels = Math.round(forecast.day.metric.temp_high) || 0;
			var nightlyHigh = forecast.night.imperial.temp_high || 0;
			var nightlyHighCels = Math.round(forecast.night.metric.temp_high) || 0;
			var maxTemp = hasDay ? forecast.imperial.temp_max || 0 : forecast.night.imperial.temp_high || 0;
			var maxTempCels = hasDay ? Math.round(forecast.metric.temp_max) || 0 : Math.round(forecast.night.metric.temp_high) || 0;
			var minTemp = forecast.imperial.temp_min || 0;
			var minTempCels = Math.round(forecast.metric.temp_min) || 0;

			var precipitationChance = (hasDay ? forecast.day.precip_prob || 0 : forecast.night.precip_prob || 0) + '%';
			var nightlyPrecipitation = (forecast.night.precip_prob || 0) + '%';
			var dailyPrecipitation = (forecast.day.precip_prob || 0) + '%';

			var dayAndMonthDisplay = validDate.getMonth() + 1 + '/' + validDate.getDate();
			var isForecastToday = Object(__WEBPACK_IMPORTED_MODULE_4__lib_is_date_today__["a" /* default */])(validDate.getTime());

			var dowDisplay = forecast.day_of_week.toLowerCase();
			var dowDayDisplay = void 0;
			var dowNightDisplay = void 0;

			if (idx === 0) {
				dowDayDisplay = { today: hasDay, tonight: !hasDay };
				dowNightDisplay = { tonight: true };
			} else {
				dowDayDisplay = { dow: dowDisplay };
				dowNightDisplay = { dow: dowDisplay, isNight: true };
			}

			var dowDetailedNightDisplay = dowNightDisplay;

			var nightlyWindSpeed = _this.createWindObject(forecast.night.wind_direction, Math.round(forecast.night.imperial.wind_speed));
			var dailyWindSpeed = _this.createWindObject(forecast.day.wind_direction, Math.round(forecast.day.imperial.wind_speed));
			var windSpeed = hasDay ? dailyWindSpeed : nightlyWindSpeed;

			var dailyNarrative = forecast.day.narrative && _this._addDegreeSymToString(forecast.day.narrative);
			var dailyNarrativeCels = forecast.day.narrative && _this._addDegreeSymToString(_this._convertDescToCelsius(forecast.day.narrative));
			var nightlyNarrative = forecast.night.narrative && _this._addDegreeSymToString(forecast.night.narrative);
			var nightlyNarrativeCels = forecast.night.narrative && _this._addDegreeSymToString(_this._convertDescToCelsius(forecast.night.narrative));

			// apeltz: @NOTE: do NOT assign these to 'null' if absent from forecast... see https://github.com/facebook/react/issues/2380
			var dailyWeatherIconCode = forecast.day.icon || '';
			var nightlyWeatherIconCode = forecast.night.icon || '';
			var weatherIconCode = dailyWeatherIconCode || nightlyWeatherIconCode;

			var simpleDesc = hasDay ? forecast.day.phrase_short : forecast.night.phrase_short;
			var humidity = (hasDay ? forecast.day.humidity || 0 : forecast.night.humidity || 0) + '%';
			var uvIndex = hasDay ? forecast.day.uv_index || 0 : forecast.night.uv_index || 0;

			return {
				dailyHigh: dailyHigh,
				dailyHighCels: dailyHighCels,
				dailyNarrative: dailyNarrative,
				dailyNarrativeCels: dailyNarrativeCels,
				dailyPrecipitation: dailyPrecipitation,
				dailyWeatherIconCode: dailyWeatherIconCode,
				dailyWindSpeed: dailyWindSpeed,
				dayAndMonthDisplay: dayAndMonthDisplay,
				dowDayDisplay: dowDayDisplay,
				dowDetailedNightDisplay: dowDetailedNightDisplay,
				dowDisplay: dowDisplay,
				dowNightDisplay: dowNightDisplay,
				hasDay: hasDay,
				humidity: humidity,
				idx: idx,
				isForecastToday: isForecastToday,
				maxTemp: maxTemp,
				maxTempCels: maxTempCels,
				minTemp: minTemp,
				minTempCels: minTempCels,
				nightlyHigh: nightlyHigh,
				nightlyHighCels: nightlyHighCels,
				nightlyNarrative: nightlyNarrative,
				nightlyNarrativeCels: nightlyNarrativeCels,
				nightlyPrecipitation: nightlyPrecipitation,
				nightlyWeatherIconCode: nightlyWeatherIconCode,
				nightlyWindSpeed: nightlyWindSpeed,
				precipitationChance: precipitationChance,
				simpleDesc: simpleDesc,
				uvIndex: uvIndex,
				validDate: validDate,
				weatherIconCode: weatherIconCode,
				windSpeed: windSpeed
			};
		};

		this.createWindObject = function (direction, speed) {
			return speed ? { direction: direction, speed: speed + 'mph' } : { calm: true };
		};

		// TODO: Still hitting Prod on UAT
		_extends(this, _extends({}, __WEBPACK_IMPORTED_MODULE_1__config__["b" /* defaults */], config));
		__WEBPACK_IMPORTED_MODULE_6__lib_weather_client__["g" /* setApiOrigin */](config.weatherServiceOrigin || __WEBPACK_IMPORTED_MODULE_1__config__["b" /* defaults */].weatherServiceOrigin);
	}

	/**
  * Query the location service
  *
  * @param {string} geoId - Unique geoID value
  * @returns {Promise<Object>}
  */


	/**
  * Query the location service to find a US Zipcode from it's geoname ID value
  *
  * @param {string} geoId - Geo ID value, i.e. "5705957"
  * @returns {Promise<string|null>}
  */


	/**
  *
  * @param number zipcode - The the zipcode corresponding to a United States
  * 							NOTE: Can we query weather endpoint with geoname or country code?
  * @param number geoId - The unique geo ID value for the location to use instead of a zipcode if it
  * 						is provided and {zipcode} isn't. This will cause an extra lookup to get
  * 						the proper US zipcode to use with our current weather endpoints
  *
  * @returns Promise<Array<Object>>
  */


	/**
  * Takes an Array of properly formatted array objects and:
  *  1: Creates a {{detailKey}} value that can be used to call the endpoint to get
  *  	a detailed description of several alerts at once
  *  2: Creates the {{alertObjects}} Array that has only the information we need
  *  	from the individual alerts
  *  3: Combines them in a single payload and returns it
  *
  *
  * @param Object	data -
  * @param Array<Object>	alerts -
  * @param string		alerts[0].detail_key - Unique alert ID
  * @param string		alerts[0].description - Short description used for the headline
  * @param string		alerts[0].severity - 'minor'|'moderate'|'high'|'severe'
  * @param string		alerts[0].source - Usually 'The Weather Channel'
  * @param number		alerts[0].expire_time_gmt - Unix timestamp for alert expiration
  * @returns Object|Throws
  * @private
  */


	WeatherModel.prototype._formatDetailedAlertDescription = function _formatDetailedAlertDescription(desc) {
		return desc.replace(/&{2}/g, '').replace(/\n{4}/g, '').replace(/(^|[^\n])\n(?!\n)/g, '$1 ') || '';
	};

	/**
  * Fetch a forecast entry in hourly increments
  *
  * @param {Number} zipCode - The zipcode to pull forecast information for
  * @returns {*}
  */


	/**
  * Takes the payload from the weather service backend service and formats it
  * nicely for use on the front end. This powers the <HourlyForecast /> component.
  *
  * @param {object} 		f
  * @param {number} 		f.valid_until - The unix timestamp value for the forecast
  * @param {number|null}	f.feels_like - The 'feels like' temperature value
  * @param {string} 		f.icon_code - Powers our different icon mappings
  * @param {string} 		f.phrase_22char - Short description of weather conditions
  * @param {number|null}	f.pop - Point of precipitation
  * @param {number|null}	f.rh - Relative humidity
  * @param {number|null}	f.temp - Temperature
  * @param {string}		f.wdir_cardinal - Cardinal wind-direciton
  * @param {string|null}	f.wspd - Wind speed
  *
  * @returns {{
  *		conditionDesc: string,
  *		dayAndMonth: string,
  *		feels: string,
  *		formattedMobileTime: string,
  *		formattedDesktopTime: string,
  *		humidity: string,
  *		iconCode: string,
  *		precipitation: string,
  *		temp: string,
  *		tempCels: string,
  *		timestamp: number,
  *		windSpeed: string
  *}}
  * @private
  */


	/**
  * Fetch a 5 day or 10 day forecast.
  *
  * Note: The Weather Channel API returns an extra entry, hence the slice(0, dayCount);
  * @param {Number} zipCode - The zipcode to pull forecast information for
  * @param {Number} dayCount - 5 or 10, the number of days to pull forecasts for
  * @returns {Promise.resolve|Promise.reject}
  */


	// apeltz: @FIXME: this formatting can probably be done with a more simple function... refactor needed


	return WeatherModel;
}();

/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

module.exports = {"clientId":"synacor","locationServiceOrigin":"https://location.imds-api.com","weatherServiceOrigin":"https://weather.imds-api.com","weatherWidgetConfig":{"trackingParams":"partner=synacor&utm_source=synacor","weatherLink":"http://www.accuweather.com","alertConfig":{"colorOverride":"#ea7400","weatherAlertNativeURL":"/weather/alerts","weatherAlertWeatherURL":"https://weather.com/weather/today/l","weatherAlertWeatherPath":":4:","weatherAlertLevels":{"none":false,"minor":true,"moderate":true,"high":true,"severe":true,"extreme":true}},"radarFullForecastCompactViewUrl":"/weather/","radarFullForecastWeatherURL":"https://weather.com/weather/today","showFiveDay":true,"useWeatherChannel":false,"weatherPath":"","weatherUrl":"https://weather.com/weather/today/m/","weatherVerticalUrl":"/weather/"},"time_series_url":"series","radar_url":"tile/radar?ts={TS}&xyz={x}:{y}:{z}","clouds_url":"tile/clouds?ts={TS}&xyz={x}:{y}:{z}","temp_url":"tile/temp?ts={TS}&xyz={x}:{y}:{z}","radar_linkOff":"http://weather.com/weather/radar/interactive/l","hourly_linkOff":"http://weather.com/weather/hourbyhour/l","today_linkOff":"http://weather.com/weather/today/l","fiveDay_linkOff":"http://weather.com/weather/5day/l","tenDay_linkOff":"http://weather.com/weather/tenday/l","alertsEndpoint":"wc/alerts/zipcode","alertDetailsEndpoint":"wc/alert/details/key","forecastEndpoint":"wc/forecast/zipcode","observationEndpoint":"wc/observation/zipcode","weather_video_host":"synacor.content-stream1.svcs.cmh.synacor.com:4080/","weather_video_url":"/player/article/","portal_proxy":true,"weatherVideoUrl":"/player/article/","streamApiOrigin":"https://content-stream.imds-api.com/","streamClient":"att-gen4","tracking":"partner=synacor&utm_source=synacor","showAlerts":true}

/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fahrenheitToCelsius;
/* unused harmony export nonMilitaryTime */
/* harmony export (immutable) */ __webpack_exports__["c"] = replaceFwdSlash;
/* harmony export (immutable) */ __webpack_exports__["b"] = handleSunFormat;
/**
 * Convert Fahrenheit to Celsius
 * @param {Number} temp
 */
function fahrenheitToCelsius(temp) {
	if (isNaN(parseFloat(temp)) && !isFinite(temp)) {
		return temp;
	}

	return Math.round((temp - 32) * 5 / 9);
}

/**
 * Converts 24-hour time to 12-hour time
 */
function nonMilitaryTime(hour) {
	if (hour > 12) {
		hour -= 12;
	} else if (hour === 0) {
		hour = 12;
	}
	return hour;
}

/**
 * Remove '/' slashes from string and replace with ', ' comma + space
 * @param {String} str  String to replace slashes in
 */
function replaceFwdSlash(str) {
	return str.replace(/\//g, ', ');
}

/**
 * Format a date object to a hh:mm string.
 * Sample date object value: 2017-02-10T17:32:51-0800
 */
function handleSunFormat(d) {
	if (d) {
		var a = d.replace(/\D/g, ' ').split(' ');
		var hour = nonMilitaryTime(~~a[3]);
		var minute = a[4];
		if (minute.toString().length === 1) {
			minute = '0' + minute;
		}
		return hour + ':' + minute;
	}
}

/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_dbee__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_dbee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__os_dbee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(598);



var getLocalTempUnit = function getLocalTempUnit(storage) {
	var _store = storage || __WEBPACK_IMPORTED_MODULE_0__os_dbee___default()(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* StorageNS */].PREFERENCES);
	var tempUnit = _store.get(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* Preferences */].TEMP_UNIT);
	return { weatherStore: _store, tempUnit: tempUnit };
};

var setLocalTempUnit = function setLocalTempUnit(tempUnit, storage) {
	var _store = storage || __WEBPACK_IMPORTED_MODULE_0__os_dbee___default()(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* StorageNS */].PREFERENCES);
	_store.set(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* Preferences */].TEMP_UNIT, tempUnit.toLowerCase());
	return { weatherStore: _store };
};

var localTempStore = {
	get: getLocalTempUnit,
	set: setLocalTempUnit
};

/* harmony default export */ __webpack_exports__["a"] = (localTempStore);

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDateToday;
function isDateToday(d) {
	var tzoffset = new Date().getTimezoneOffset() * 60000; //user's offset in milliseconds
	return new Date(d).toISOString().slice(0, 'YYYY-MM-DD'.length) === new Date(Date.now() - tzoffset).toISOString().slice(0, 'YYYY-MM-DD'.length);
}

/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setApiOrigin; });
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchDailyForecast;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchCurrentConditions;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAlerts;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAlertDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchHourlyForecast;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchTimeSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__weather_api__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(598);



/**
 * The "Weather Client" is a place for normalizing, error handling, logging, and tracking.
 */

var setApiOrigin = __WEBPACK_IMPORTED_MODULE_0__weather_api__["g" /* setApiOrigin */];

function fetchDailyForecast(latitude, longitude) {
	var dayCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DEFAULT_FORECAST_DAYS */];

	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return __WEBPACK_IMPORTED_MODULE_0__weather_api__["d" /* fetchDailyForecast */](latitude, longitude, dayCount);
}

function fetchCurrentConditions(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return __WEBPACK_IMPORTED_MODULE_0__weather_api__["c" /* fetchCurrentConditions */](latitude, longitude);
}

function fetchAlerts(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return __WEBPACK_IMPORTED_MODULE_0__weather_api__["b" /* fetchAlerts */](latitude, longitude);
}

function fetchAlertDetails(alertKey) {
	return __WEBPACK_IMPORTED_MODULE_0__weather_api__["a" /* fetchAlertDetails */](alertKey);
}

function fetchHourlyForecast(latitude, longitude) {
	var hours = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DEFAULT_HOURLY_FORECAST_NUM_HOURS */];

	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return __WEBPACK_IMPORTED_MODULE_0__weather_api__["e" /* fetchHourlyForecast */](latitude, longitude, hours).then(function (data) {
		return data.forecasts;
	});
}

function fetchTimeSeries(type, latitude, longitude, size) {
	if (!type || !latitude || !longitude || !size) {
		return Promise.reject('A required parameter is missing.');
	}

	return __WEBPACK_IMPORTED_MODULE_0__weather_api__["f" /* fetchTimeSeries */](type, latitude, longitude, size);
}

/***/ }),

/***/ 1129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = setApiOrigin;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchCurrentConditions;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchDailyForecast;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAlerts;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAlertDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchHourlyForecast;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchTimeSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch__);


// 5 minute cache age.
var MAX_AGE = 5 * 60 * 1000;

/**
 * Please keep this file as simple as possible. The `Weather API` should return raw responses.
 * If there is a need for normalization, perform that in the `Weather Client` file/module.
 */

var apiOrigin = '';

function validateApiOrigin() {
	if (!apiOrigin || !apiOrigin.length) {
		apiOriginError();
	}
}

function apiOriginError() {
	var err = 'WeatherAPI ERROR: Invalid apiOrigin: ' + apiOrigin;
	if (false) {
		throw new Error(err);
	} else {
		console.error(err);
	}
}

function limitPrecision(latitude, longitude) {
	return [Number(latitude).toFixed(2), Number(longitude).toFixed(2)];
}

function setApiOrigin(url) {
	if (url && url.charAt(url.length - 1) === '/') {
		url = url.substr(0, url.length - 1);
	}
	apiOrigin = url;
	validateApiOrigin();
}

function fetchCurrentConditions(latitude, longitude) {
	var _limitPrecision = limitPrecision(latitude, longitude);

	latitude = _limitPrecision[0];
	longitude = _limitPrecision[1];

	validateApiOrigin();
	return __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default()(apiOrigin + '/current/location/' + latitude + ',' + longitude + '/', {}, MAX_AGE);
}

function fetchDailyForecast(latitude, longitude, dayCount) {
	var _limitPrecision2 = limitPrecision(latitude, longitude);

	latitude = _limitPrecision2[0];
	longitude = _limitPrecision2[1];

	validateApiOrigin();
	return __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default()(apiOrigin + '/forecast/daily/location/' + latitude + ',' + longitude + '/days/' + dayCount + '/', {}, MAX_AGE);
}

function fetchAlerts(latitude, longitude) {
	var _limitPrecision3 = limitPrecision(latitude, longitude);

	latitude = _limitPrecision3[0];
	longitude = _limitPrecision3[1];

	validateApiOrigin();
	return __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default()(apiOrigin + '/alerts/location/' + latitude + ',' + longitude + '/', {}, MAX_AGE);
}

function fetchAlertDetails(alertKey) {
	validateApiOrigin();
	return __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default()(apiOrigin + '/wc/alert/details/key/' + alertKey, {}, MAX_AGE);
}

function fetchHourlyForecast(latitude, longitude, hours) {
	var _limitPrecision4 = limitPrecision(latitude, longitude);

	latitude = _limitPrecision4[0];
	longitude = _limitPrecision4[1];

	validateApiOrigin();
	return __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default()(apiOrigin + '/forecast/hourly/location/' + latitude + ',' + longitude + '/hours/' + hours + '/', {}, MAX_AGE);
}

function fetchTimeSeries(type, latitude, longitude, size) {
	var _limitPrecision5 = limitPrecision(latitude, longitude);

	latitude = _limitPrecision5[0];
	longitude = _limitPrecision5[1];

	validateApiOrigin();
	return __WEBPACK_IMPORTED_MODULE_0__cube_utils_lib_json_fetch___default()(apiOrigin + '/images/' + type + '/location/' + latitude + ',' + longitude + '/size/' + size + '/', {}, MAX_AGE);
}

/***/ }),

/***/ 1130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CurrentLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_location__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_current_location__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_json__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__intl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);





function intlWrap(Child) {
	return Object(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["e" /* default */])(Child, {
		scope: 'location-widget',
		definition: __WEBPACK_IMPORTED_MODULE_2__intl_json___default.a
	});
}

/* harmony default export */ __webpack_exports__["a"] = (intlWrap(__WEBPACK_IMPORTED_MODULE_0__components_location__["a" /* default */]));

var CurrentLocation = intlWrap(__WEBPACK_IMPORTED_MODULE_1__components_current_location__["a" /* default */]);

/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Location */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_location_model__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_debounce__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__os_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__location_popover__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__location_textinput__ = __webpack_require__(1152);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Location = (_temp2 = _class = function (_Component) {
	_inherits(Location, _Component);

	function Location() {
		var _temp, _this, _ret;

		_classCallCheck(this, Location);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			searchTerm: ''
		}, _this.handleSetCurrent = function (location) {
			var _this$props = _this.props,
			    isCurrent = _this$props.isCurrent,
			    isRecent = _this$props.isRecent,
			    onChangeRecent = _this$props.onChangeRecent,
			    onChangeCurrent = _this$props.onChangeCurrent,
			    recent = _this$props.recent;


			if (isCurrent && isCurrent(location)) {
				return;
			}

			if (isRecent && !isRecent(location)) {
				onChangeRecent && onChangeRecent([location].concat(recent));
			}

			_this.setState({ searchTerm: '' });

			onChangeCurrent && onChangeCurrent(location);
		}, _this.handleAddFavorite = function (location) {
			var _this$props2 = _this.props,
			    favorites = _this$props2.favorites,
			    isFavorite = _this$props2.isFavorite,
			    onChangeFavorites = _this$props2.onChangeFavorites;

			// TODO: Sorting?

			favorites = [].concat(isFavorite && isFavorite(location) ? favorites.filter(function (favLoc) {
				return favLoc.id !== location.id;
			}) : favorites, [location]);

			_this.handleSetCurrent(location);
			onChangeFavorites && onChangeFavorites(favorites);
		}, _this.handleDismissFavorite = function (location) {
			var _this$props3 = _this.props,
			    favorites = _this$props3.favorites,
			    recent = _this$props3.recent,
			    isRecent = _this$props3.isRecent,
			    onChangeFavorites = _this$props3.onChangeFavorites,
			    onChangeRecent = _this$props3.onChangeRecent;


			favorites = favorites.filter(function (favLoc) {
				return favLoc.id !== location.id;
			});

			recent = [location].concat(isRecent && isRecent(location) ? recent.filter(function (recentLoc) {
				return recentLoc.id !== location.id;
			}) : recent);

			onChangeFavorites && onChangeFavorites(favorites);
			onChangeRecent && onChangeRecent(recent);
		}, _this.handleSearchInput = function (searchTerm) {
			_this.setState({ searchTerm: searchTerm });
			_this.props.onChangeSearchTerm && _this.props.onChangeSearchTerm(searchTerm);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Location.prototype.componentWillMount = function componentWillMount() {
		var _props = this.props,
		    current = _props.current,
		    onChange = _props.onChange;

		if (current) {
			onChange && onChange(current);
		}
	};

	Location.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
		var current = _ref.current,
		    onChange = _ref.onChange;

		if (current && (this.props.current && this.props.current.id) !== current.id) {
			onChange && onChange(current);
		}
	};

	Location.prototype.render = function render(_ref2, _ref3) {
		var searchTerm = _ref3.searchTerm;

		var maxFavorites = _ref2.maxFavorites,
		    maxRecent = _ref2.maxRecent,
		    _ref2$primary = _ref2.primary,
		    primary = _ref2$primary === undefined ? {} : _ref2$primary,
		    _ref2$current = _ref2.current,
		    current = _ref2$current === undefined ? {} : _ref2$current,
		    _ref2$favorites = _ref2.favorites,
		    favorites = _ref2$favorites === undefined ? [] : _ref2$favorites,
		    _ref2$recent = _ref2.recent,
		    recent = _ref2$recent === undefined ? [] : _ref2$recent,
		    isFavorite = _ref2.isFavorite,
		    searchResults = _ref2.searchResults,
		    label = _ref2.label,
		    fullWidth = _ref2.fullWidth,
		    props = _objectWithoutProperties(_ref2, ['maxFavorites', 'maxRecent', 'primary', 'current', 'favorites', 'recent', 'isFavorite', 'searchResults', 'label', 'fullWidth']);

		var isFavoritesFull = favorites.length >= maxFavorites;
		var recentWithoutFavorites = recent.filter(function (recentLoc) {
			return isFavorite && !isFavorite(recentLoc);
		}).slice(0, maxRecent);
		var pending = !current.id;

		var Child = fullWidth ? __WEBPACK_IMPORTED_MODULE_5__location_textinput__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__location_popover__["a" /* default */];
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, _extends({}, props, {
			pending: pending,
			isFavoritesFull: isFavoritesFull,
			maxFavorites: maxFavorites,
			maxRecent: maxRecent,
			primary: primary,
			current: current,
			favorites: favorites,
			recent: recentWithoutFavorites,
			searchResults: searchResults,
			label: label,
			searchTerm: searchTerm,
			isFavorite: isFavorite,
			onSearchInput: this.handleSearchInput,
			onSetCurrent: this.handleSetCurrent,
			onAddFavorite: this.handleAddFavorite,
			onDismissFavorite: this.handleDismissFavorite
		}));
	};

	return Location;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	maxFavorites: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* MAX_FAVORITES */],
	maxRecent: __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* MAX_RECENTLY_SEARCHED */]
}, _temp2);

function enhance(Child) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__cube_location_model__["a" /* withLocationModel */])(function (locations) {
		return locations;
	}, function (model, ownProps) {
		return {
			onChangeCurrent: function onChangeCurrent(location) {
				model.actions.change.current(location);
				ownProps.onChange && ownProps.onChange(location);
			},
			onChangeFavorites: model.actions.change.favorites,
			onChangeRecent: model.actions.change.recent,
			onChangeSearchTerm: __WEBPACK_IMPORTED_MODULE_2__os_debounce___default()(model.actions.change.searchTerm, __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* SEARCHING_DELAY */]),
			isPrimary: model.is.primary,
			isCurrent: model.is.current,
			isRecent: model.is.recent,
			isFavorite: model.is.favorites
		};
	})(Child);
}

/* harmony default export */ __webpack_exports__["a"] = (enhance(Location));

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setAPIOrigin;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchGeoLocation;
/* harmony export (immutable) */ __webpack_exports__["c"] = search;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchGeonames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_resource__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_utils_lib_json_fetch__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_utils_lib_json_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cube_utils_lib_json_fetch__);



// 5 minute cache age.
var MAX_AGE = 5 * 60 * 1000;

var apiURL = null;

function validateApiURL() {
	if (!apiURL || !apiURL.length) {
		apiURLError();
	}
}

function apiURLError() {
	var err = 'LocationAPI ERROR: Invalid apiURL: ' + apiURL;
	if (false) {
		throw new Error(err);
	} else {
		console.error(err);
	}
}

function setAPIOrigin(url) {
	if (url && url.charAt(url.length - 1) === '/') {
		url = url.substr(0, url.length - 1);
	}
	apiURL = url;
	validateApiURL();
}

function fetchGeoLocation() {
	validateApiURL();
	return __WEBPACK_IMPORTED_MODULE_1__cube_utils_lib_json_fetch___default()(apiURL + '/ip/?fields=verbose', {}, MAX_AGE);
}

function search(query, international) {
	validateApiURL();
	return Object(__WEBPACK_IMPORTED_MODULE_0__get_resource__["a" /* default */])(apiURL, query, international).then(function (url) {
		return __WEBPACK_IMPORTED_MODULE_1__cube_utils_lib_json_fetch___default()(url, {}, MAX_AGE);
	});
}

function fetchGeonames(geonames) {
	validateApiURL();
	return __WEBPACK_IMPORTED_MODULE_1__cube_utils_lib_json_fetch___default()(apiURL + '/search/?geoname_id=' + geonames.join('&geoname_id=') + '&fields=verbose', {}, MAX_AGE);
}

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getResource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__(744);



/** Get the respective resource based on the location type provided
* @param {String} origin The service's origin.
* @param {String} query The search term(s) the user is looking for.
* @returns {String} URI url to web resource providing location services
*/
function getResource(origin, query, international) {
	var usOnly = !international ? '&country_iso_code=us' : '';

	return __WEBPACK_IMPORTED_MODULE_1__storage__["a" /* default */].get().then(function (loc) {
		var lat = loc.current.latitude,
		    lon = loc.current.longitude,
		    latlon = lat && lon ? '&current_loc=' + lat + ',' + lon : '';

		query = encodeURIComponent(query);

		return origin + '/search/?query=' + query + '&fields=verbose&rows=' + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MAX_SEARCH_ROWS */] + latlon + usOnly;
	}).catch(function (e) {
		return origin + '/search/?query=' + query + '&fields=verbose&rows=' + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MAX_SEARCH_ROWS */] + usOnly;
	});
}

/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeLocation;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function normalizeLocation(loc, searchTerm) {
	// if it's US, metro_code will be set, so use the state name, otherwise use non-US country name
	searchTerm = searchTerm ? String(searchTerm).trim() : '';

	var state = loc.metro_code ? loc.subdivision_1_iso_code : loc.country_name,
	    name = loc.city_name + ', ' + state;
	return _extends({}, loc, {
		name: name,
		city: loc.city_name,
		state: state,
		geoname_id: loc.geoname_id, //guard
		postal_code: loc.postal_code, //guard
		matched_postal_code: loc.postal_code && loc.postal_code[loc.postal_code.indexOf(searchTerm)], // if we queried an exact ZIP code
		query: searchTerm, //what got us here
		id: name + '|' + loc.geoname_id
	});
}

/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_default_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preconf__ = __webpack_require__(32);



var configure = Object(__WEBPACK_IMPORTED_MODULE_1_preconf__["a" /* default */])(null, __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default.a);

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

module.exports = {"locationServiceOrigin":"https://location.imds-api.com","supportInternationalLocations":false,"defaultLocation":{"city_name":"Buffalo","country_name":"United States","geoname_id":5110629,"latitude":42.8864,"longitude":-78.8781,"metro_code":"514","postal_code":"14225","subdivision_1_iso_code":"NY","subdivision_1_name":"New York","city":"Buffalo","state":"NY"}}

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__primary_location__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_for_location__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__favorite_locations__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recent_locations__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading_text__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(1151);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var LocationPopover = (_temp2 = _class = function (_Component) {
	_inherits(LocationPopover, _Component);

	function LocationPopover() {
		var _temp, _this, _ret;

		_classCallCheck(this, LocationPopover);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	}

	LocationPopover.prototype.render = function render(_ref, _ref2) {
		var active = _ref2.active;

		var pending = _ref.pending,
		    maxFavorites = _ref.maxFavorites,
		    maxRecent = _ref.maxRecent,
		    _ref$primary = _ref.primary,
		    primary = _ref$primary === undefined ? {} : _ref$primary,
		    _ref$current = _ref.current,
		    current = _ref$current === undefined ? {} : _ref$current,
		    _ref$favorites = _ref.favorites,
		    favorites = _ref$favorites === undefined ? [] : _ref$favorites,
		    _ref$recent = _ref.recent,
		    recent = _ref$recent === undefined ? [] : _ref$recent,
		    searchResults = _ref.searchResults,
		    label = _ref.label,
		    searchTerm = _ref.searchTerm,
		    onSearchInput = _ref.onSearchInput,
		    onSetCurrent = _ref.onSetCurrent,
		    onAddFavorite = _ref.onAddFavorite,
		    onDismissFavorite = _ref.onDismissFavorite,
		    isFavoritesFull = _ref.isFavoritesFull,
		    isFavorite = _ref.isFavorite,
		    props = _objectWithoutProperties(_ref, ['pending', 'maxFavorites', 'maxRecent', 'primary', 'current', 'favorites', 'recent', 'searchResults', 'label', 'searchTerm', 'onSearchInput', 'onSetCurrent', 'onAddFavorite', 'onDismissFavorite', 'isFavoritesFull', 'isFavorite']);

		delete props.onChange;
		delete props.onChangeCurrent;
		delete props.onChangeFavorites;
		delete props.onChangeRecent;
		delete props.onChangeSearchTerm;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["n" /* Popover */],
			_extends({
				anchor: 'right'
			}, props, {
				active: active,
				onToggle: this.handlePopoverToggle,
				focusAfterClosing: true,
				containerClass: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.container, props.containerClass, props.class),
				popoverClass: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.popover, props.popoverClass),
				toggleClass: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.button, props.toggleClass),
				text: pending && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__loading_text__["a" /* default */], { color: 'gray' }) || label || current.name || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: 'changeLocation' }),
				icon: 'location-cube',
				iconPosition: 'left'
			}, __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* TRACKING */]),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__search_for_location__["b" /* default */], { value: searchTerm, onInput: onSearchInput, refocus: active }),
			searchTerm && searchTerm.length ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__search_for_location__["a" /* SearchResults */], {
				locations: searchResults,
				onSetCurrent: this.handleSetCurrent,
				onAddFavorite: !isFavoritesFull && this.handleAddFavorite,
				isFavorite: isFavorite,
				isFavoritesFull: isFavoritesFull
			}) : [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__primary_location__["a" /* default */], { location: primary, onSetCurrent: this.handleSetCurrent }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__favorite_locations__["a" /* default */], {
				locations: favorites,
				maxFavorites: maxFavorites,
				onSetCurrent: this.handleSetCurrent,
				onDismissFavorite: onDismissFavorite
			}), Boolean(recent.length) && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__recent_locations__["a" /* default */], {
				locations: recent,
				maxFavorites: maxFavorites,
				onSetCurrent: this.handleSetCurrent,
				onAddFavorite: !isFavoritesFull && this.handleAddFavorite,
				isFavoritesFull: isFavoritesFull
			})]
		);
	};

	return LocationPopover;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.handlePopoverToggle = function (active) {
		_this2.setState({ active: active });
	};

	this.closePopover = function () {
		_this2.setState({ active: false });
	};

	this.handleSetCurrent = function () {
		var _props;

		_this2.props.onSetCurrent && (_props = _this2.props).onSetCurrent.apply(_props, arguments);
		_this2.closePopover();
	};

	this.handleAddFavorite = function () {
		var _props2;

		_this2.props.onAddFavorite && (_props2 = _this2.props).onAddFavorite.apply(_props2, arguments);
		_this2.closePopover();
	};
}, _temp2);


/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"location_icon-header_header","hidden":"location_icon-header_hidden","icon":"location_icon-header_icon"};

/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export freezeIDCounter */
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaIDProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var frozen = false;

// For testing purposes only
function freezeIDCounter() {
	if (false) {
		frozen = true;
	}
}

var A11Y_ID_COUNTERS = {};

function ariaIDProvider(baseName) {
	A11Y_ID_COUNTERS[baseName] = (A11Y_ID_COUNTERS[baseName] || 0) + 1;

	return function (Child) {
		return function (_Component) {
			_inherits(AriaIDProvider, _Component);

			function AriaIDProvider() {
				_classCallCheck(this, AriaIDProvider);

				var _this = _possibleConstructorReturn(this, _Component.call(this));

				if (!frozen) {
					A11Y_ID_COUNTERS[baseName] += 1;
				}

				_this.a11yId = baseName + '_' + A11Y_ID_COUNTERS[baseName];
				return _this;
			}

			AriaIDProvider.prototype.render = function render(props) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, _extends({}, props, { a11yId: this.a11yId }));
			};

			return AriaIDProvider;
		}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
	};
}

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScreenReaderText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



// See http://webaim.org/techniques/css/invisiblecontent/#absolutepositioning
function ScreenReaderText(_ref) {
	var children = _ref.children,
	    props = _objectWithoutProperties(_ref, ['children']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		_extends({}, props, { style: 'position:absolute; left:-10000px; top:auto; width:1px; height:1px; overflow:hidden;' }),
		children
	);
}

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"location_locations-list_container","list":"location_locations-list_list"};

/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return A11Y_ICON_LABEL_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACKING_MAP; });

var A11Y_ICON_LABEL_MAP = {
	star: 'Add favorite',
	trash: 'Remove favorite',
	'current-location': 'Default location'
};

var TRACKING_MAP = {
	switch: makeTracking('switch-location'),
	star: makeTracking('add-location-favorite'),
	trash: makeTracking('remove-location-favorite')
};

function makeTracking(id) {
	return { 'data-tracking-id': id };
}

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"primaryLocation":"location_primary-location_primaryLocation"};

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inputContainer":"location_search-for-location_inputContainer","searchResults":"location_search-for-location_searchResults","focusStar":"location_search-for-location_focusStar","isFavorite":"location_search-for-location_isFavorite","disabled":"location_search-for-location_disabled"};

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FavoritesCounter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function FavoritesCounter(_ref) {
	var numFavorites = _ref.numFavorites,
	    maxFavorites = _ref.maxFavorites,
	    props = _objectWithoutProperties(_ref, ['numFavorites', 'maxFavorites']);

	var maxReached = numFavorites >= maxFavorites;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(maxReached && __WEBPACK_IMPORTED_MODULE_1__style___default.a.maxReached, props.class) }),
		'(' + numFavorites + '/' + maxFavorites + ')',
		maxReached && ' Max Reached'
	);
}

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"maxReached":"location_favorites-counter_maxReached"};

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"favorites":"location_favorite-locations_favorites","focusTrash":"location_favorite-locations_focusTrash"};

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"focusStar":"location_recent-locations_focusStar","disabled":"location_recent-locations_disabled"};

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading":"location_loading-text_loading","gray":"location_loading-text_gray"};

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"location_location-popover_container","popover":"location_location-popover_popover","button":"location_location-popover_button"};

/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING; });
var TRACKING = {
	'data-tracking-id': 'pick-location'
};

/***/ }),

/***/ 1152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationTextInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__primary_location__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_for_location__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__favorite_locations__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recent_locations__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading_text__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(1154);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var LocationTextInput = (_temp2 = _class = function (_Component) {
	_inherits(LocationTextInput, _Component);

	function LocationTextInput() {
		var _temp, _this, _ret;

		_classCallCheck(this, LocationTextInput);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	}

	LocationTextInput.prototype.render = function render(_ref, _ref2) {
		var open = _ref2.open;

		var pending = _ref.pending,
		    onSearchInput = _ref.onSearchInput,
		    onSetCurrent = _ref.onSetCurrent,
		    onAddFavorite = _ref.onAddFavorite,
		    onDismissFavorite = _ref.onDismissFavorite,
		    maxFavorites = _ref.maxFavorites,
		    maxRecent = _ref.maxRecent,
		    isFavoritesFull = _ref.isFavoritesFull,
		    isFavorite = _ref.isFavorite,
		    isPrimary = _ref.isPrimary,
		    isCurrent = _ref.isCurrent,
		    _ref$primary = _ref.primary,
		    primary = _ref$primary === undefined ? {} : _ref$primary,
		    _ref$current = _ref.current,
		    current = _ref$current === undefined ? {} : _ref$current,
		    _ref$favorites = _ref.favorites,
		    favorites = _ref$favorites === undefined ? [] : _ref$favorites,
		    _ref$recent = _ref.recent,
		    recent = _ref$recent === undefined ? [] : _ref$recent,
		    searchResults = _ref.searchResults,
		    label = _ref.label,
		    searchTerm = _ref.searchTerm,
		    props = _objectWithoutProperties(_ref, ['pending', 'onSearchInput', 'onSetCurrent', 'onAddFavorite', 'onDismissFavorite', 'maxFavorites', 'maxRecent', 'isFavoritesFull', 'isFavorite', 'isPrimary', 'isCurrent', 'primary', 'current', 'favorites', 'recent', 'searchResults', 'label', 'searchTerm']);

		delete props.onChange;
		delete props.onChangeCurrent;
		delete props.onChangeFavorites;
		delete props.onChangeRecent;
		delete props.onChangeSearchTerm;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["c" /* ClickOutsideDetector */],
			{ onClickOutside: open && this.handleCloseInput },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.container, open && __WEBPACK_IMPORTED_MODULE_8__style___default.a.open, props.class) },
				!open ? [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_8__style___default.a.toggleContainer },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'button',
						_extends({}, props, {
							'class': __WEBPACK_IMPORTED_MODULE_8__style___default.a.toggleButton,
							anchor: 'right',
							icon: 'location-cube',
							iconPosition: 'left',
							onClick: this.handleOpenInput
						}, __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* TRACKING */]),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["i" /* Icon */], { name: 'location-cube' }),
						' ',
						pending ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__loading_text__["a" /* default */], null) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'p',
							null,
							label || current.name || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: 'changeLocation' })
						)
					)
				), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'button',
					{ 'class': __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.iconButton, isFavorite && isFavorite(current) && __WEBPACK_IMPORTED_MODULE_8__style___default.a.favorite), onClick: this.handleAddCurrentToFavorites },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["i" /* Icon */], { name: isPrimary && isPrimary(current) ? 'current-location-wire-cube' : 'star-cube' })
				)] : [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__search_for_location__["b" /* default */], { value: searchTerm, onInput: onSearchInput, hideHeader: true, refocus: open }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_8__style___default.a.dropdown },
					searchTerm && searchTerm.length ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__search_for_location__["a" /* SearchResults */], {
						locations: searchResults,
						onSetCurrent: this.handleSetCurrent,
						onAddFavorite: !isFavoritesFull && this.handleAddFavorite,
						isFavorite: isFavorite,
						isFavoritesFull: isFavoritesFull
					}) : [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__primary_location__["a" /* default */], { location: primary, onSetCurrent: this.handleSetCurrent }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__favorite_locations__["a" /* default */], {
						locations: favorites,
						maxFavorites: maxFavorites,
						onSetCurrent: this.handleSetCurrent,
						onDismissFavorite: onDismissFavorite
					}), Boolean(recent.length) && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__recent_locations__["a" /* default */], {
						locations: recent,
						maxFavorites: maxFavorites,
						onSetCurrent: this.handleSetCurrent,
						onAddFavorite: !isFavoritesFull && this.handleAddFavorite,
						isFavoritesFull: isFavoritesFull
					})]
				)]
			)
		);
	};

	return LocationTextInput;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.handleOpenInput = function () {
		_this2.setState({ open: true });
	};

	this.handleCloseInput = function () {
		_this2.setState({ open: false });
	};

	this.handleSetCurrent = function () {
		var _props;

		_this2.props.onSetCurrent && (_props = _this2.props).onSetCurrent.apply(_props, arguments);
		_this2.handleCloseInput();
	};

	this.handleAddFavorite = function () {
		var _props2;

		_this2.props.onAddFavorite && (_props2 = _this2.props).onAddFavorite.apply(_props2, arguments);
		_this2.handleCloseInput();
	};

	this.handleAddCurrentToFavorites = function () {
		var _props3 = _this2.props,
		    isFavoritesFull = _props3.isFavoritesFull,
		    isFavorite = _props3.isFavorite,
		    current = _props3.current,
		    onAddFavorite = _props3.onAddFavorite,
		    onDismissFavorite = _props3.onDismissFavorite;

		isFavorite && isFavorite(current) ? onDismissFavorite && onDismissFavorite(current) : !isFavoritesFull && onAddFavorite && onAddFavorite(current);
	};
}, _temp2);


/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"location_location-textinput_container","toggleContainer":"location_location-textinput_toggleContainer","toggleButton":"location_location-textinput_toggleButton","iconButton":"location_location-textinput_iconButton","favorite":"location_location-textinput_favorite","open":"location_location-textinput_open","dropdown":"location_location-textinput_dropdown"};

/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING; });

var TRACKING = {
	'data-tracking-id': 'pick-location'
};

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CurrentLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_location_model__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Consider moving MAX_FAVORITES to the model.
// Consider adding "is.full.favorites" and "is.full.recent"
var CurrentLocation = (_temp2 = _class = function (_Component) {
	_inherits(CurrentLocation, _Component);

	function CurrentLocation() {
		var _temp, _this, _ret;

		_classCallCheck(this, CurrentLocation);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleAddFavorite = function () {
			var _this$props = _this.props,
			    _this$props$favorites = _this$props.favorites,
			    favorites = _this$props$favorites === undefined ? [] : _this$props$favorites,
			    current = _this$props.current,
			    onChangeFavorites = _this$props.onChangeFavorites,
			    maxFavorites = _this$props.maxFavorites;

			var isFavoritesFull = favorites.length >= maxFavorites;
			!isFavoritesFull && onChangeFavorites && onChangeFavorites(favorites.concat(current));
		}, _this.handleRemoveFavorite = function () {
			var _this$props2 = _this.props,
			    _this$props2$favorite = _this$props2.favorites,
			    favorites = _this$props2$favorite === undefined ? [] : _this$props2$favorite,
			    isCurrent = _this$props2.isCurrent,
			    isCurrentPrimary = _this$props2.isCurrentPrimary,
			    onChangeFavorites = _this$props2.onChangeFavorites;


			!isCurrentPrimary && onChangeFavorites && onChangeFavorites(favorites.filter(function (favorite) {
				return isCurrent && !isCurrent(favorite);
			}));
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CurrentLocation.prototype.render = function render(_ref) {
		var _ref$current = _ref.current,
		    current = _ref$current === undefined ? {} : _ref$current,
		    _ref$favorites = _ref.favorites,
		    favorites = _ref$favorites === undefined ? [] : _ref$favorites,
		    isCurrentInFavorites = _ref.isCurrentInFavorites,
		    isCurrentPrimary = _ref.isCurrentPrimary,
		    onChangeFavorites = _ref.onChangeFavorites,
		    props = _objectWithoutProperties(_ref, ['current', 'favorites', 'isCurrentInFavorites', 'isCurrentPrimary', 'onChangeFavorites']);

		var isFavoritesFull = favorites.length >= __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* MAX_FAVORITES */];

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'button',
			_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style___default.a.button, props.class), onClick: !isCurrentInFavorites ? this.handleAddFavorite : this.handleRemoveFavorite }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.truncate },
				current.name || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'currentLocation' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["i" /* Icon */], {
				'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style___default.a.icon, isCurrentInFavorites ? !isCurrentPrimary && __WEBPACK_IMPORTED_MODULE_5__style___default.a.favorited : isFavoritesFull && __WEBPACK_IMPORTED_MODULE_5__style___default.a.full),
				name: isCurrentPrimary ? 'current-location-wire-cube' : 'star-cube'
			})
		);
	};

	return CurrentLocation;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	maxFavorites: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* MAX_FAVORITES */]
}, _temp2);

function enhance(Child) {
	return Object(__WEBPACK_IMPORTED_MODULE_2__cube_location_model__["a" /* withLocationModel */])(function (_ref2) {
		var current = _ref2.current,
		    favorites = _ref2.favorites;
		return { current: current, favorites: favorites };
	}, function (model, ownProps) {
		return {
			onChangeFavorites: model.actions.change.favorites,
			isCurrentInFavorites: model.is.favorites(ownProps.current),
			isCurrentPrimary: model.is.primary(ownProps.current),
			isCurrent: model.is.current
		};
	})(Child);
}

/* harmony default export */ __webpack_exports__["a"] = (enhance(CurrentLocation));

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"location_current-location_button","truncate":"location_current-location_truncate","icon":"location_current-location_icon","full":"location_current-location_full","favorited":"location_current-location_favorited"};

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

module.exports = {"location-widget":{"asOf":"As of","search":"Search for a location","recentlySearched":"Recently Searched","favoritesHeader":"Favorites","inputPlaceholder":"Enter ZIP or City & State","maxReached":"Max Reached","maxReachedDefaultViewFirstLine":"Max.","maxReachedDefaultViewSecondLine":"reached!","currentLocation":"Current Location","changeLocation":"Change Location","pickALocation":"Pick a Location","loading":"Finding Location..."}}

/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__current__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forecast__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);








var Weather = function Weather(_ref) {
	var conditions = _ref.conditions,
	    currentUnit = _ref.currentUnit,
	    config = _ref.config,
	    forecast = _ref.forecast,
	    weatherLink = _ref.weatherLink,
	    trackingParams = _ref.trackingParams,
	    clientId = _ref.clientId,
	    alerts = _ref.alerts,
	    weatherAlertUrl = _ref.weatherAlertUrl,
	    changeUnit = _ref.changeUnit,
	    _ref$showRadarFullFor = _ref.showRadarFullForecastLink,
	    showRadarFullForecastLink = _ref$showRadarFullFor === undefined ? true : _ref$showRadarFullFor,
	    showAlerts = _ref.showAlerts;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ key: 'container', 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.container },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__current__["a" /* default */], {
				today: conditions,
				unit: currentUnit,
				changeUnit: changeUnit
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__forecast__["a" /* default */], { forecasts: forecast.slice(0, 3), unit: currentUnit })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.moreOnAndradarFullForecast },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.moreOn },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */], { id: 'moreOn' }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{ href: weatherLink, target: '_blank', rel: 'noopener noreferrer' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */], { id: 'accuWeather' })
				)
			),
			showRadarFullForecastLink && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.radarFullForecast },
				config.useWeatherChannel ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{
						href: config.radarFullForecastWeatherURL,
						target: '_blank',
						rel: 'noopener noreferrer'
					},
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */], { id: 'radarFullForecast' })
				) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{ href: config.weatherVerticalUrl },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */], { id: 'radarFullForecast' })
				)
			)
		),
		alerts && alerts.description && showAlerts && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__alert__["a" /* default */], {
			alertColor: __WEBPACK_IMPORTED_MODULE_4_dlv___default()(config, 'alertConfig.colorOverride') || alerts.color,
			alertCount: __WEBPACK_IMPORTED_MODULE_4_dlv___default()(alerts, 'totalAlerts'),
			alertText: alerts.description,
			alertURL: weatherAlertUrl,
			openNewWindow: config.useWeatherChannel
		})
	);
};
/* harmony default export */ __webpack_exports__["a"] = (Weather);

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"current":"weather_current_x","temperature":"weather_current_temperature","temp":"weather_current_temp","degreePicker":"weather_current_degreePicker","fahrenheit":"weather_current_fahrenheit","celsius":"weather_current_celsius","active":"weather_current_active","icon":"weather_current_icon","conditionIcon":"weather_current_conditionIcon","description":"weather_current_description","compact":"weather_current_compact"};

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(33).then((function(require) {
		cb(__webpack_require__(1161));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__weather_svg_icon___ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__(9);






var todayOrTonight = function todayOrTonight() {
	var curTime = new Date();
	curTime = parseInt(curTime.getHours(), 10);
	if (curTime >= 19) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: 'tonight' });
	}
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: 'today' });
};

/**
 * Render the Forecast component
 * @param  {Array} {forecasts} Contains 0 or more objects with forecast data
 */
var Forecast = function Forecast(_ref) {
	var forecasts = _ref.forecasts,
	    unit = _ref.unit;

	var hiTempSelector = unit === 'C' ? 'maxTempCels' : 'maxTemp';
	var loTempSelector = unit === 'C' ? 'minTempCels' : 'minTemp';
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.forecast },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.forecast__icons },
			forecasts.map(function (forecast) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.day },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'p',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.dow },
						forecast.dowDisplay && (forecast.isForecastToday ? todayOrTonight() : forecast.dowDisplay.slice(0, 3))
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.icons },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__weather_svg_icon___["a" /* default */], { name: forecast.weatherIconCode, 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.conditionIcon) })
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'p',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a['hi-lo'] },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'span',
							null,
							forecast[hiTempSelector],
							'\xB0'
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'span',
							{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a['min-degrees'] },
							forecast[loTempSelector],
							'\xB0'
						)
					)
				);
			})
		)
	);
};
/* harmony default export */ __webpack_exports__["a"] = (Forecast);

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"forecast":"weather_forecast_x","forecast__icons":"weather_forecast_x__icons","day":"weather_forecast_day","dow":"weather_forecast_dow","hi-lo":"weather_forecast_hi-lo","min-degrees":"weather_forecast_min-degrees","icons":"weather_forecast_icons","conditionIcon":"weather_forecast_conditionIcon"};

/***/ }),

/***/ 1165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAlertColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/**
 * Render the Current Weather component
 * @param  {Object} The current alerts, and postal code, for this location
 * @return {String} The rendered component
 */
var WeatherAlerts = function WeatherAlerts(_ref) {
	var alertColor = _ref.alertColor,
	    alertLevel = _ref.alertLevel,
	    alertCount = _ref.alertCount,
	    alertText = _ref.alertText,
	    alertURL = _ref.alertURL,
	    openNewWindow = _ref.openNewWindow;

	var additionalAttributes = openNewWindow ? { target: '_blank', rel: 'noopener noreferrer' } : {};
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'a',
		_extends({ href: alertURL }, additionalAttributes),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style___default.a.alert, __WEBPACK_IMPORTED_MODULE_1__style___default.a[alertLevel]), style: getAlertColor(alertColor) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style___default.a.message) },
				alertText
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style___default.a.more) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["i" /* Icon */], { name: 'alert-wire-cube' }),
				' ',
				alertCount
			)
		)
	);
};

var getAlertColor = function getAlertColor(color) {
	return 'background: ' + color;
};

/* harmony default export */ __webpack_exports__["a"] = (WeatherAlerts);

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"alert":"weather_alert_x","popIn":"weather_alert_popIn","moderate":"weather_alert_moderate","minor":"weather_alert_minor","high":"weather_alert_high","severe":"weather_alert_severe","extreme":"weather_alert_extreme","show":"weather_alert_show","message":"weather_alert_message","alertContent":"weather_alert_alertContent","more":"weather_alert_more"};

/***/ }),

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__current__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);







var WeatherCompact = function WeatherCompact(_ref) {
	var conditions = _ref.conditions,
	    currentUnit = _ref.currentUnit,
	    config = _ref.config,
	    location = _ref.location,
	    changeUnit = _ref.changeUnit;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["f" /* DeviceVariance */], { other: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ key: 'container', 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a.container, __WEBPACK_IMPORTED_MODULE_4__style___default.a.compact) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__current__["a" /* default */], {
				isCompact: true,
				today: conditions,
				unit: currentUnit,
				changeUnit: changeUnit
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.moreOnAndradarFullForecast },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.radarFullForecast },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: config.radarFullForecastCompactViewUrl, target: '_blank', rel: 'noopener noreferrer' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'radarFullForecast' })
					)
				)
			)
		), phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ key: 'container', 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a.container, __WEBPACK_IMPORTED_MODULE_4__style___default.a.compact, __WEBPACK_IMPORTED_MODULE_4__style___default.a.phone) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__current__["a" /* default */], {
				isCompact: true,
				today: conditions,
				unit: currentUnit,
				changeUnit: changeUnit
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.moreOnAndradarFullForecast },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.radarFullForecast },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'span',
							{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.location },
							location.name
						)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: config.radarFullForecastCompactViewUrl, target: '_blank', rel: 'noopener noreferrer' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'radarFullForecast' })
					)
				)
			)
		)
	});
};
/* harmony default export */ __webpack_exports__["a"] = (WeatherCompact);

/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);




var ErrorMessage = function ErrorMessage() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.errorMsg },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
				{ id: 'error-line-1' },
				'Oops, something went wrong.'
			)
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
				{ id: 'error-line-2' },
				'Please check back shortly.'
			)
		)
	);
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorMessage);

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"errorMsg":"weather_error-msg_errorMsg"};

/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WeatherSpinner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





function WeatherSpinner(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.loading, props.class), style: props.style },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["r" /* Spinner */], { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.spinner })
		)
	);
}

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading":"weather_spinner_loading","spinner":"weather_spinner_x"};

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

module.exports = {"weather-widget":{"weather":"Weather","poweredby":"Powered by The Weather Channel®","weathercom":"weather.com","accuWeather":"AccuWeather.com","moreOn":"More on ","radarFullForecast":"Radar & Full Forecast","alert":{"minor":{"singular":"Weather Advisory","plural":"Weather Advisories"},"moderate":{"singular":"Weather Advisory","plural":"Weather Advisories"},"high":{"singular":"Weather Alert","plural":"Weather Alerts"},"severe":{"singular":"Weather Alert","plural":"Weather Alerts"},"extreme":{"singular":"Weather Alert","plural":"Weather Alerts"}},"error-line-1":"Oops, something went wrong.","error-line-2":"Please check back shortly.","today":"Today","tonight":"Tonight"},"weather-vertical-widget":{"alert":{"advisory":{"singular":"1 Advisory","plural":"{{num}} Advisories"},"severe":{"singular":"1 Alert","plural":"{{num}} Alerts"}},"am":"am","asOf":"As of","cTemp":"C°","calm":"Calm","clouds":"Clouds","shortDays":{"monday":"Mo","tuesday":"Tu","wednesday":"We","thursday":"Th","friday":"Fr","saturday":"Sa","sunday":"Su"},"days":{"monday":"Mon","tuesday":"Tue","wednesday":"Wed","thursday":"Thu","friday":"Fri","saturday":"Sat","sunday":"Sun"},"desktopDailyForecastConditionHeader":"Conditions","desktopDailyForecastDayHeader":"Day","desktopDailyForecastHighLowHeader":"High/Low","desktopDailyForecastHumidityHeader":"Humidity","desktopDailyForecastPrecipitationHeader":"Precipitation","desktopDailyForecastUVIndexHeader":"UV Index","desktopDailyForecastWindHeader":"Wind","dewPoint":"Dew Point","error-component":{"errorMessageLineOne":"Oops, something went wrong.","errorMessageLineTwo":"Please check back shortly."},"fTemp":"F°","feelsLike":"Feels Like","fiveDayForecast":"5 Day Forecast","fiveday":"5 Day","heat":"Heat","high":"High","hourly":"Hourly","interactiveRadar":"Interactive Radar","lookingAheadDay":"Day","lookingAheadHeader":"looking ahead","lookingAheadHourly":"Hourly","lookingAheadToday":"today","lookingAheadTonight":"tonight","low":"Low","mobileDailyForecastDayHeader":"Day","mobileDailyForecastConditionHeader":"Cond.","mobileDailyForecastTemperatureHeader":"Temp","mobileDailyForecastPrecipitationHeader":"Precip.","mobileDailyForecastWindHeader":"Wind","mobileHourlyForecastTimeHeader":"Time","mobileHourlyForecastConditionHeader":"Cond.","mobileHourlyForecastTemperatureHeader":"Temp","mobileHourlyForecastPrecipitationHeader":"Precip.","mobileHourlyForecastWindHeader":"Wind","moreFromWeatherChannel":"More from The Weather Channel ©","moreFromAccuWeather":"More on AccuWeather.com","night":"Night","nextHoursInDailyForecast":"Next {{num}} Hours","pm":"pm","poweredBy":"powered by","moreOn":"More on","pressure":"Pressure","radar":"Radar","radarDesktop":"Radar & Maps","source":"Source","sunrise":"Sunrise","sunset":"Sunset","tenDayForecast":"10 Day Forecast","tenday":"10 Day","theWeatherChannel":"The Weather Channel","accuWeather":"AccuWeather.com","thereAreNoWeatherAdvisories":"There are no active weather advisories for this location.","today":"Today","tonight":"Tonight","until":"Until","uvIndexText":"{{uvIndex}} out of 10","visibility":"Visibility","weather":"Weather"}}

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeatherWidget", function() { return WeatherWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeatherCompact", function() { return WeatherCompact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_weather__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_json__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__intl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





// import { SplitPoint } from '@os/split-point';
// import intl, { IntlProvider } from 'preact-i18n';
// import load from 'bundle-loader?lazy&name=widgets/weather-vertical!./components/weather-vertical';
// import createStore from './lib/store';
// import Provider from  'preact-context-provider';
// import { Tabs } from './lib/constants';
// import WeatherMap from './components/map';
// import { WeatherModel } from './model';
// import { DeviceVariance, RenderOnVisible } from '@cube/blocks';

function intlWrap(component) {
	return Object(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["e" /* default */])(component, { scope: 'weather-widget', definition: __WEBPACK_IMPORTED_MODULE_2__intl_json___default.a });
}

var WeatherWidget = intlWrap(__WEBPACK_IMPORTED_MODULE_1__components_weather__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = (WeatherWidget);
var WeatherCompact = intlWrap(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__components_weather__["a" /* default */], _extends({}, props, { compact: true }));
});

// weather-vertical-widget

/** Comment out the following until they are used again to reduce bundle and css size

// export const Radar = enhance((props) => (
// 	<div id="radar" style="min-height: 350px;">
// 		<RenderOnVisible>
// 			<DeviceVariance
// 				adaptive
// 				phone={<WeatherMap mapSize="small" />}
// 				other={<WeatherMap mapSize="medium" size="large" />}
// 			/>
// 		</RenderOnVisible>
// 	</div>
// ));

export function UnenhancedWeatherVerticalWidget(props) {
	if (!props.baseURL) {
		props.baseURL = '/weather';
	}
	return (
		<SplitPoint
			{...props}
			load={load}
		/>
	);
}

export const WeatherVerticalWidget = enhance(UnenhancedWeatherVerticalWidget);


function enhance(Child) {
	return class Enhancer extends Component {
		constructor(props, context) {
			super(props, context);
			this.weather = new WeatherModel({
				weatherServiceOrigin: props.weatherServiceOrigin,
				locationServiceOrigin: props.locationServiceOrigin
			});

			this.store = context.store || createStore([], {
				tempUnit: 'f',
				activeTab: Tabs.TODAY
			});

			let state = this.store.getState();
			if (!state || !state.activeTab) {
				this.store.setState({ activeTab: Tabs.TODAY });
			}
		}

		render({ weatherServiceOrigin, locationServiceOrigin, ...props }) {
			return (
				<IntlProvider scope="weather-vertical-widget" definition={definition}>
					<Provider store={this.store} weather={this.weather}>
						<Child {...props} />
					</Provider>
				</IntlProvider>
			);
		}
	};
}

*/

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wire;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(375);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



 // eslint-disable-line no-unused-vars

/**	Creates a higher order component (HOC) that resolves (async) values from a model to props.
 *	This allows (but importantly abstracts) context access, and manages re-rendering in response to resolved data.
 *	`wire()` is simply a formalization of what is typically done as side-effects within `componentDidMount()`.
 *
 *	@name wire
 *	@param {String} [contextNamespace]		The context property at which to obtain a model instance. If empty, all of `context` is used.
 *	@param {Object|Function} [mapToProps]	Maps incoming props to model method call descriptors: `['method.name', ...args]`
 *	@param {Function} [mapModelToProps]		Maps model properties/methods to props: `model => ({ prop: model.property })`
 *	@returns {Function} wiring(Child) -> WireDataWrapper<Child>.  The resulting HOC has a method `getWrappedComponent()` that returns the Child that was wrapped
 *
 *	@example
 *	// resolves news.getTopStories(), passing it down as a "stories" prop
 *	let withTopStories = wire('news', {
 *		stories: 'getTopStories'
 *	});
 *	export default withTopStories( props =>
 *		<ul>
 *			{ props.stories.map( item =>
 *				<li>{item.title}</li>
 *			) }
 *		</ul>
 *	);
 *
 *	@example
 *	// resolves a news story by ID and passes it down as a "story" prop
 *	let withStory = wire('news', props => ({
 *		story: ['getStory', props.id]
 *	}));
 *
 *	// Simple "view" functional component to render a story
 *	const StoryView = ({ story }) => (
 *		<div class="story">
 *			<h2>{story ? story.title : '...'}</h2>
 *			<p>{story && story.content}</p>
 *		</div>
 *	);
 *
 *	// Wrap StoryView in the loader component created by wire()
 *	const Story = withStory(StoryView);
 *
 *	//Get access to the wrapped Component
 *	Story.getWrappedComponent() === StoryView; // true
 *
 *	// Provide a news model into context so Story can wire up to it
 *	render(
 *		<Provider news={newsModel({ origin: '//news.api' })}>
 *			<div class="demo">
 *				<h1>News Story #1234:</h1>
 *				<Story id="1234" />
 *			</div>
 *		</Provider>
 *	);
 */
function wire(contextNamespace) {
	var mapToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var mapModelToProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__util__["c" /* noop */];

	var CACHE = {};

	return function (Child) {
		var WireDataWrapper = function (_Component) {
			_inherits(WireDataWrapper, _Component);

			WireDataWrapper.prototype.invoke = function invoke(props, keysOnly, refresh) {
				var _this2 = this;

				var source = Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* get */])(this.context, contextNamespace),
				    isFunction = typeof mapToProps === 'function',
				    mapping = isFunction ? mapToProps(props) : mapToProps,
				    keys = [];

				var _loop = function _loop(prop) {
					if (Object.prototype.hasOwnProperty.call(mapping, prop)) {
						var path = mapping[prop],
						    args = [];
						if (Array.isArray(path)) {
							args = path.slice(1);
							path = path[0];
						}
						if (!isFunction) {
							args = args.map(function (p) {
								return typeof p === 'string' && p in props ? props[p] : p;
							});
						}

						var key = JSON.stringify([contextNamespace, path].concat(args));
						keys.push(key);
						if (keysOnly) return 'continue';

						if (!refresh && _this2.currentKeys[prop] === key) {
							return 'continue';
						}

						_this2.currentKeys[prop] = key;

						var p = void 0;
						if (typeof path === 'function') {
							p = path();
						} else if (typeof path !== 'string') {
							p = path;
						} else {
							var fn = __WEBPACK_IMPORTED_MODULE_1_dlv___default()(source, path);
							if (!fn) throw Error(contextNamespace + '.' + path + ' not found.');
							p = fn.apply(undefined, args);
						}

						if (p && p.then !== undefined && p.__wiretieResolved) {
							p = p.__wiretieResolved;
						}

						// magically re-render for async values:
						if (p && p.then !== undefined) {

							var newState = {};
							var _state = _this2.state,
							    pending = _state.pending,
							    rejected = _state.rejected;

							// set that this property call is pending if not already set

							if (!pending) {
								var _newState$pending;

								newState.pending = (_newState$pending = {}, _newState$pending[prop] = true, _newState$pending);
							} else if (!pending[prop]) {
								var _extends2;

								newState.pending = _extends({}, pending, (_extends2 = {}, _extends2[prop] = true, _extends2));
							}

							// Since we're starting a new call for prop, remove any old rejected status for it if it exists
							if (rejected && rejected[prop]) {
								newState.rejected = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* removeKeyFromObject */])(prop, rejected);
							}

							var id = ++_this2.counter;
							_this2.tracking[prop] = id;

							// handle the promise results
							p.then(function (data) {
								p.__wiretieResolved = data;

								// cache the result if the promise resolved successfully
								var newState = {};
								newState[prop] = CACHE[key] = data;
								return newState;
							}).catch(function (err) {
								if (_this2.tracking[prop] !== id) return;

								// If there was an error, use the cached value if available and set the rejected property
								var rejected = _this2.state.rejected && _extends({}, _this2.state.rejected) || {};
								rejected[prop] = err;
								var newState = { rejected: rejected };
								if (CACHE[key]) newState[prop] = CACHE[key];

								//Anonymous rejection to log to the console
								Promise.reject(err);

								return newState;
							}).then(function (newState) {
								if (_this2.tracking[prop] !== id) return;
								delete _this2.tracking[prop];

								// remove the pending key for this prop if necessary
								var pending = _this2.state.pending;
								if (pending && pending[prop]) newState.pending = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* removeKeyFromObject */])(prop, pending);
								_this2.setState(newState);
							});

							// if we got a Promise but there's a cached value, use that until the new value comes in:
							if (typeof CACHE[key] !== 'undefined') {
								newState[prop] = CACHE[key];
							}
							_this2.setState(newState);
						} else {
							var _this2$setState;

							//for non-promises, just set the state with the value
							_this2.setState((_this2$setState = {}, _this2$setState[prop] = p, _this2$setState));
						}
					}
				};

				for (var prop in mapping) {
					var _ret = _loop(prop);

					if (_ret === 'continue') continue;
				}return this.keys = keys;
			};

			function WireDataWrapper(props, context) {
				_classCallCheck(this, WireDataWrapper);

				var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

				_this.state = {};
				_this.currentKeys = {};

				// used for creating unique IDs.
				_this.tracking = {};
				_this.counter = 0;

				_this.mapping = mapModelToProps(Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* get */])(context, contextNamespace), props);

				/** Props passed to your wrapped component.
     *	@name props
     */

				/** If any Promises are pending, the corresponding prop names will be keys in a `props.pending` Object.
    		 *	If there are no pending promises, `props.pending` is `undefined`.
     *	@name pending
     *	@memberof props
     *	@type {Object<Boolean>|undefined}
     */

				/** If any Promises have been rejected, their values are available in a `props.rejected` Object.
    	 *	If there are no rejected promises, `props.rejected` is `undefined`.
    	 *	@name rejected
     *	@memberof props
    	 *	@type {Object<Error>|undefined}
    	 */

				/** A `refresh()` method is passed down as a prop.
     *	Invoking this method re-fetches all data props, bypassing the cache.
     *	@name refresh
     *	@memberof props
     *	@function
     */
				_this.refresh = function () {
					_this.invoke(_this.props, false, true);
				};
				return _this;
			}

			WireDataWrapper.prototype.componentWillMount = function componentWillMount() {
				this.invoke(this.props);
			};

			WireDataWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
				if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(nextProps, this.props) && Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* join */])(this.keys) !== Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* join */])(this.invoke(nextProps, true))) {
					this.invoke(nextProps);
				}
			};

			WireDataWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(props, state) {
				return !Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(props, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(state, this.state);
			};

			WireDataWrapper.prototype.render = function render(props, state) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, _extends({ refresh: this.refresh }, this.mapping, props, state));
			};

			return WireDataWrapper;
		}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

		WireDataWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
			return Child;
		};
		return WireDataWrapper;
	};
}

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = join;
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["e"] = shallowEqual;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeKeyFromObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = noop;
/* unused harmony export assign */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/** Joins an array (using newlines) if it exists, otherwise returns an empty string
 *	@private
 */
function join(arr) {
	return arr ? arr.join('\n') : '';
}

/** Returns an object property if `key` is non-empty, otherwise returns the object itself
 *	@private
 */
function get(obj, key) {
	return key ? obj[key] : obj;
}

/** Check if two objects have the same keys, and that all values are strictly equal.
 *	@private
 */
function shallowEqual(a, b) {
	for (var key in a) {
		if (a[key] !== b[key]) return false;
	}for (var _key in b) {
		if (!(_key in a)) return false;
	}return true;
}

/** Returns a clone of the given object without a certain key.
 *	Returns undefined if resulting object would be empty.
 *	@private
 */
function removeKeyFromObject(key, obj) {
	if (Object.prototype.hasOwnProperty.call(obj, key)) {
		obj = _extends({}, obj);
		delete obj[key];
	}
	return Object.keys(obj).length ? obj : undefined;
}

/** An empty function.
 *	@private
 */
function noop() {}

/** Object.assign ponyfill (note: used by Rollup)
 *	@private
 */
function assign(obj) {
	for (var i = 1; i < arguments.length; i++) {
		// eslint-disable-next-line guard-for-in, prefer-rest-params
		for (var p in arguments[i]) {
			obj[p] = arguments[i][p];
		}
	}
	return obj;
}

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_header__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__a11y__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LocationsList = (_dec = Object(__WEBPACK_IMPORTED_MODULE_2__a11y__["b" /* default */])('locations-list'), _dec(_class = function (_Component) {
	_inherits(LocationsList, _Component);

	function LocationsList() {
		_classCallCheck(this, LocationsList);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	// eslint-disable-line react/prefer-stateless-function
	LocationsList.prototype.render = function render(_ref) {
		var header = _ref.header,
		    headerIcon = _ref.headerIcon,
		    a11yId = _ref.a11yId,
		    children = _ref.children,
		    hideHeader = _ref.hideHeader,
		    live = _ref.live,
		    props = _objectWithoutProperties(_ref, ['header', 'headerIcon', 'a11yId', 'children', 'hideHeader', 'live']);

		// If the header is visible, use `aria-lablledby` with the ID of the header. Otherwise, use aria-label or blank.
		var listLabel = !hideHeader ? { 'aria-labelledby': a11yId } : props['aria-label'] ? { 'aria-label': props['aria-label'] } : {};

		delete props['aria-label'];

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.container, props.class) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__icon_header__["a" /* default */],
				{ id: a11yId, hidden: hideHeader, icon: headerIcon },
				header
			),
			live && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_2__a11y__["a" /* ScreenReaderText */],
				{ 'aria-live': 'polite' },
				live
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ol',
				_extends({ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.list }, listLabel),
				children
			)
		);
	};

	return LocationsList;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);


/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__a11y__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1142);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var IconListItem = function (_Component) {
	_inherits(IconListItem, _Component);

	function IconListItem() {
		var _temp, _this, _ret;

		_classCallCheck(this, IconListItem);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClickLocation = function () {
			_this.props.onClickLocation && _this.props.onClickLocation(_this.props.location);
		}, _this.handleClickIcon = function () {
			_this.props.onClickIcon && _this.props.onClickIcon(_this.props.location);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	IconListItem.prototype.render = function render(_ref) {
		var onClickIcon = _ref.onClickIcon,
		    icon = _ref.icon,
		    location = _ref.location,
		    a11yId = _ref.a11yId,
		    props = _objectWithoutProperties(_ref, ['onClickIcon', 'icon', 'location', 'a11yId']);

		var btnDisabled = !onClickIcon;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'li',
			props,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				_extends({ id: a11yId, onClick: this.handleClickLocation, href: 'javascript:' }, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* TRACKING_MAP */].switch),
				location.name
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'button',
				_extends({ tabindex: btnDisabled && -1, onClick: this.handleClickIcon }, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* TRACKING_MAP */][icon]),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["i" /* Icon */], { 'aria-labelledby': a11yId, name: icon }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_2__a11y__["a" /* ScreenReaderText */],
					null,
					__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* A11Y_ICON_LABEL_MAP */][icon]
				)
			)
		);
	};

	return IconListItem;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__a11y__["b" /* default */])('icon-list-item')(IconListItem));

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SplitPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FALLBACK = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'loading' },
	'Loading....'
);

/* harmony default export */ __webpack_exports__["a"] = (function (load, importName) {
	return function (props) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SplitPoint, _extends({ load: load, importName: importName }, props));
	};
});

var SplitPoint = function (_Component) {
	_inherits(SplitPoint, _Component);

	function SplitPoint() {
		_classCallCheck(this, SplitPoint);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SplitPoint.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		var setChild = function setChild(child) {
			if (_this2.props.importName) {
				child = child[_this2.props.importName] || child;
			}
			if (child && (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && child.default) {
				child = child.default;
			}
			if (child !== _this2.state.child) {
				_this2.setState({ child: child });
			}
		};

		var ret = this.props.load(setChild);
		if (ret && ret.then) ret.then(setChild);
	};

	SplitPoint.prototype.render = function render(_ref, _ref2) {
		var child = _ref2.child;

		var load = _ref.load,
		    fallbackContent = _ref.fallbackContent,
		    props = _objectWithoutProperties(_ref, ['load', 'fallbackContent']);

		return child ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(child, props) : fallbackContent || FALLBACK;
	};

	return SplitPoint;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony export (immutable) */ __webpack_exports__["b"] = provide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** Adds all passed props into context, making them available to all descendants.
 *
 *	To learn about context, see the [React Docs](https://facebook.github.io/react/docs/context.html).
 *
 *	@name Provider
 *
 * @example
 * const Demo = (props, context) => {
 *   console.log(context.a);  // "b"
 * };
 * render(
 *   <Provider a="b">
 *     <Demo />
 *   </Provider>
 * )
 */

var Provider = function () {
  function Provider() {
    _classCallCheck(this, Provider);
  }

  Provider.prototype.getChildContext = function getChildContext() {
    var context = {};
    for (var i in this.props) {
      if (this.props.hasOwnProperty(i) && i !== 'children') {
        context[i] = this.props[i];
      }
    }
    return context;
  };

  Provider.prototype.render = function render(_ref) {
    var children = _ref.children;

    return children[0];
  };

  return Provider;
}();




Provider.provide = provide;

/**
 * Utility function to wrap a component in a {@link Provider} tag
 *
 * @param {Object} ctx props to be passed to the {@link Provider} component
 * @return {Function} A function that, given a Child component, wraps it in a Provider component with the applied ctx props
 *
 * @example
 * const Demo = (props, context) => {
 *   console.log(context.a);  // "b"
 * };
 * const ProvidedDemo = provide({a: "b"})(Demo);
 *
 * render( <ProvidedDemo /> );
 */
function provide(ctx) {
  return function (Child) {
    return function (props) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Provider,
        ctx,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, props)
      );
    };
  };
}

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tabs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StorageNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Preferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Errors; });
/* unused harmony export DEFAULT_TEMP_UNIT */
/* unused harmony export DEFAULT_DAILY_FORECAST_NUM_DAYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_HOURLY_FORECAST_NUM_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_FORECAST_DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOON; });
var Tabs = {
	TODAY: 0,
	HOURLY: 1,
	FIVEDAY: 2,
	TENDAY: 3,
	RADAR: 4
};

var StorageNS = {
	PREFERENCES: 'sync-user-preferences'
};

var Preferences = {
	TEMP_UNIT: 'temp-unit'
};

var Errors = {
	NO_ALERT_DETAILS_FOUND: 901,
	NO_DETAIL_KEY_FOUND: 901
};

var DEFAULT_TEMP_UNIT = 'f',
    DEFAULT_DAILY_FORECAST_NUM_DAYS = 10,
    DEFAULT_HOURLY_FORECAST_NUM_HOURS = 24,
    DEFAULT_FORECAST_DAYS = 5,
    NOON = 12;

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__provider__ = __webpack_require__(1139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__provider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screen_reader_text__ = __webpack_require__(1140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__screen_reader_text__["a"]; });





/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rotate":"weather_x_rotate","weather":"weather_x_x","location":"weather_x_location","popover":"weather_x_popover","header":"weather_x_header","links":"weather_x_links","poweredBy":"weather_x_poweredBy","moreOn":"weather_x_moreOn","radarFullForecast":"weather_x_radarFullForecast","moreOnAndradarFullForecast":"weather_x_moreOnAndradarFullForecast","container":"weather_x_container","compact":"weather_x_compact","phone":"weather_x_phone"};

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preconf__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_demo_config_json__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_demo_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_demo_config_json__);

// These configs are only used when developing the component locally; in
// production config is provided by tesseract through context


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_preconf__["a" /* default */])(null, __WEBPACK_IMPORTED_MODULE_1__config_demo_config_json___default.a));
var defaults = __WEBPACK_IMPORTED_MODULE_1__config_demo_config_json___default.a;

/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(741);
/* unused harmony reexport LocationModel2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_provider__ = __webpack_require__(745);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__model_provider__["a"]; });
/* unused harmony reexport LocationProvider */







/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLocationModel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mitt__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_location_client__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_storage__ = __webpack_require__(744);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





// TODO: Use ES6 Set https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
var initialState = {
	primary: {}, // Primary is the geolocation.
	current: {},
	favorites: [],
	recent: [],
	searchResults: []
};

/**
 * The location model. :rocket:
 */
function createLocationModel(_ref) {
	var _ref$config = _ref.config,
	    config = _ref$config === undefined ? {} : _ref$config;

	var events = Object(__WEBPACK_IMPORTED_MODULE_0_mitt__["a" /* default */])();

	var state = _extends({}, initialState, config.initialState || {});

	function refresh() {
		events.emit('refresh', state);
	}

	function init() {
		var apiOrigin = config.apiOrigin,
		    defaultLocation = config.defaultLocation;

		apiOrigin && __WEBPACK_IMPORTED_MODULE_1__lib_location_client__["d" /* setAPIOrigin */](apiOrigin);

		__WEBPACK_IMPORTED_MODULE_2__lib_storage__["a" /* default */].init(defaultLocation).then(function (nextState) {
			state = _extends({}, state, nextState);
			refresh();
		});

		events.on('refresh', function (_ref2) {
			var primary = _ref2.primary,
			    current = _ref2.current,
			    favorites = _ref2.favorites,
			    recent = _ref2.recent;

			var saveState = { primary: primary, current: current, favorites: favorites, recent: recent };
			__WEBPACK_IMPORTED_MODULE_2__lib_storage__["a" /* default */].set(saveState);
		});
	}

	var is = {
		primary: function primary(location) {
			return state.primary.id === location.id;
		},
		current: function current(location) {
			return state.current.id === location.id;
		},
		favorites: function favorites(location) {
			return Boolean(state.favorites.filter(function (favoriteLocation) {
				return favoriteLocation.id === location.id;
			}).length);
		},
		recent: function recent(location) {
			return Boolean(state.recent.filter(function (recentLocation) {
				return recentLocation.id === location.id;
			}).length);
		}
	};

	var get = {
		primary: function primary() {
			return state.primary;
		},
		current: function current() {
			return state.current;
		},
		favorites: function favorites() {
			return state.favorites;
		},
		recent: function recent() {
			return state.recent;
		},
		searchResults: function searchResults() {
			return state.searchResults;
		}
	};

	var set = {
		current: function current(location) {
			state.current = location;
		},
		favorites: function favorites(locations) {
			state.favorites = locations;
		},
		recent: function recent(locations) {
			state.recent = locations;
		}
	};

	var actions = {
		change: {
			current: function current(newCurrent) {
				if (!is.current(newCurrent)) {
					set.current(newCurrent);
					refresh();
				}
			},
			favorites: function favorites(newFavorites) {
				set.favorites(newFavorites);
				refresh();
			},
			recent: function recent(newRecent) {
				set.recent(newRecent);
				refresh();
			},
			searchTerm: function searchTerm(_searchTerm) {
				return __WEBPACK_IMPORTED_MODULE_1__lib_location_client__["c" /* search */](_searchTerm, config.international).then(function (results) {
					state.searchResults = results;
					refresh();
				});
			}
		}
	};

	var on = {
		refresh: function refresh(callback) {
			events.on('refresh', callback);
			callback(state); // Immediately send a refresh to the new subscriber, to ensure they have the latest state.

			return function destroy() {
				events.off('refresh', callback);
			};
		}
	};

	init();

	return {
		setAPIOrigin: __WEBPACK_IMPORTED_MODULE_1__lib_location_client__["d" /* setAPIOrigin */],
		on: on,
		is: is,
		get: get,
		set: set,
		actions: actions
	};
}

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setAPIOrigin; });
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchGeonames;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchGeoLocation;
/* harmony export (immutable) */ __webpack_exports__["c"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_api__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalize_location__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(743);




var setAPIOrigin = __WEBPACK_IMPORTED_MODULE_0__location_api__["d" /* setAPIOrigin */];

function fetchGeonames(geonames, defaultLocation) {
	geonames = [].concat(geonames);
	return __WEBPACK_IMPORTED_MODULE_0__location_api__["b" /* fetchGeonames */](geonames).then(function (body) {
		return body.documents && body.documents.reduce(function (acc, current) {
			var normalized = Object(__WEBPACK_IMPORTED_MODULE_1__normalize_location__["a" /* default */])(current);
			if (!normalized.geoname_id || !normalized.postal_code) return acc;
			acc.push(normalized);
			return acc;
		}, []);
	}).catch(function (e) {
		return [defaultLocation];
	});
}

function fetchGeoLocation(defaultLocation) {
	return __WEBPACK_IMPORTED_MODULE_0__location_api__["a" /* fetchGeoLocation */]().then(function (location) {
		var response = Object(__WEBPACK_IMPORTED_MODULE_1__normalize_location__["a" /* default */])(location);
		response.expiry = Date.now() + __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* GEOLOCATION_EXPIRY_TIME */];
		return response;
	}).catch(function () {
		console.warn('LocationModel: Could not Geolocate, using default geolocation.'); // eslint-disable-line no-console
		var response = Object(__WEBPACK_IMPORTED_MODULE_1__normalize_location__["a" /* default */])(defaultLocation);
		response.expiry = Date.now() + __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* GEOLOCATION_FAILURE_EXPIRY_TIME */];
		return response;
	});
}

function search(searchTerm, international) {
	//return empty promise on invalid input
	if (!searchTerm) return Promise.resolve([]);
	return __WEBPACK_IMPORTED_MODULE_0__location_api__["c" /* search */](searchTerm, international).then(function (body) {
		if (body.documents && body.count > 0) {
			body.documents = body.documents.reduce(function (cleanedArray, loc) {
				// to be useful, we need a result with a city or a postal_code
				if (!loc.city_name || !loc.postal_code) return cleanedArray;
				cleanedArray.push(Object(__WEBPACK_IMPORTED_MODULE_1__normalize_location__["a" /* default */])(loc, searchTerm));
				return cleanedArray;
			}, []);
			return body.documents;
		}
		return [];
	});
}

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GEOLOCATION_EXPIRY_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GEOLOCATION_FAILURE_EXPIRY_TIME; });
/* unused harmony export MAX_FAVORITES */
/* unused harmony export MAX_RECENTLY_SEARCHED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_SEARCH_ROWS; });
/* unused harmony export SUPPORT_INTL_LOCATIONS */
var GEOLOCATION_EXPIRY_TIME = 3600000;
var GEOLOCATION_FAILURE_EXPIRY_TIME = 600000;

var MAX_FAVORITES = 5;
var MAX_RECENTLY_SEARCHED = 5;
var MAX_SEARCH_ROWS = 30;

var SUPPORT_INTL_LOCATIONS = true;

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_dbee__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_dbee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__os_dbee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location_client__ = __webpack_require__(742);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable camelcase */




var localStorage = __WEBPACK_IMPORTED_MODULE_0__os_dbee___default()('location-model');
var STORAGE_KEY = 'locations';
var EXPIRY_KEY = 'expiry';
var STORAGE_VERSION = '2';

/* harmony default export */ __webpack_exports__["a"] = ({ get: get, set: set, init: init });

function versionControl(rawStorage) {
	if (rawStorage && +rawStorage.version !== +STORAGE_VERSION) {
		localStorage.clear();
		rawStorage = undefined;
	}
	return rawStorage;
}

function get(defaultLocation) {
	return Promise.resolve(processFromCache(versionControl(localStorage.get(STORAGE_KEY)), defaultLocation));
}

function set(locations) {
	locations.version = STORAGE_VERSION;
	localStorage.set(STORAGE_KEY, processToCache(locations));
}

function init(defaultLocation) {
	return get(defaultLocation).then(function (cached) {
		var state = void 0;

		if (cached && cached.favorites) {
			console.info('LocationModel: Using locations from cache:', cached); // eslint-disable-line no-console
			state = _extends({}, state, cached);
		}

		var isPrimaryLocationExpired = isLocationExpired(cached && cached.primary);
		isPrimaryLocationExpired && localStorage.remove(EXPIRY_KEY);

		return {
			state: state,
			isPrimaryLocationExpired: isPrimaryLocationExpired
		};
	}).then(function (_ref) {
		var _ref$state = _ref.state,
		    state = _ref$state === undefined ? {} : _ref$state,
		    isPrimaryLocationExpired = _ref.isPrimaryLocationExpired;
		return isPrimaryLocationExpired ? Object(__WEBPACK_IMPORTED_MODULE_1__location_client__["a" /* fetchGeoLocation */])(defaultLocation).then(function (location) {
			state.primary = location;

			state.current = state.current || location;

			// If the location is the primary location and no expiration is set, set a new expiration.
			var expiry = localStorage.get(EXPIRY_KEY);
			if (!expiry && location.expiry) {
				localStorage.set(EXPIRY_KEY, location.expiry);
			}

			return state;
		}) : state;
	});
}

function isLocationExpired(location) {
	return !location || (location.expiry || 0) <= Date.now();
}

function processToCache() {
	var allLocations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	// remove favorites that are also recent searches.
	allLocations.recent = allLocations.recent && allLocations.recent.filter(function (recentLoc) {
		return allLocations.favorites.map(function (favorite) {
			return favorite.id;
		}).indexOf(recentLoc.id) < 0;
	}).slice(0, 5);

	// process locations into geonamesId
	return Object.keys(allLocations).reduce(function (acc, key) {
		if (key === 'version') {
			acc[key] = allLocations[key];return acc;
		}

		var locations = allLocations[key];

		acc[key] = Array.isArray(locations) ? locations.map(function (_ref2) {
			var geoname_id = _ref2.geoname_id;
			return +geoname_id;
		}) : +locations.geoname_id;

		return acc;
	}, {});
}

function processFromCache(cached, defaultLocation) {
	// flatten all geonames into one request.
	var cacheKeys = cached && Object.keys(cached);
	if (!cacheKeys || !cacheKeys.length) {
		return;
	}

	cacheKeys.forEach(function (key) {
		if (!cached[key]) delete cached[key];
	});
	delete cached.version;
	cacheKeys = Object.keys(cached);

	// Flatten and batch geonames into one request.
	var allGeonameIds = cacheKeys.reduce(function (acc, key) {
		return acc.concat(cached[key]);
	}, []);

	return Object(__WEBPACK_IMPORTED_MODULE_1__location_client__["b" /* fetchGeonames */])(allGeonameIds, defaultLocation).then(function (locations) {
		// Re-shape the locations back to { primary, current, favorites, recent }
		var locationObj = cacheKeys.reduce(function (acc, key) {
			var geonameIds = cached[key];
			acc[key] = !Array.isArray(geonameIds) ? locations.filter(function (_ref3) {
				var geoname_id = _ref3.geoname_id;
				return +geonameIds === +geoname_id;
			})[0] : locations.filter(function (_ref4) {
				var geoname_id = _ref4.geoname_id;
				return geonameIds.some(function (geonameId) {
					return +geonameId === +geoname_id;
				});
			});
			return acc;
		}, {});
		var expiry = localStorage.get(EXPIRY_KEY);
		if (locationObj.primary && expiry) {
			locationObj.primary.expiry = expiry;
		}
		// Ensure favorites exists, even if empty
		if (!locationObj.favorites) locationObj.favorites = [];
		return locationObj;
	}).catch(function (err) {
		return console.error('location-model processFromCache error: ', err);
	});
}

/* eslint-enable camelcase */

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withLocationModel;
/* unused harmony export LocationProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_shallow_equal__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_shallow_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__os_shallow_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context_provider__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(741);
var _dec, _class2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function noop() {}

var Model = void 0;
function withLocationModel() {
	var mapStateToProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	var mapDispatchToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

	return function enhance(Child) {
		return Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* configure */])('locationServiceOrigin,supportInternationalLocations,defaultLocation')(function (_Component) {
			_inherits(LocationModelProvider, _Component);

			function LocationModelProvider() {
				var _temp, _this, _ret;

				_classCallCheck(this, LocationModelProvider);

				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}

				return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocations = function (locations) {
					_this.setState(locations);
				}, _temp), _possibleConstructorReturn(_this, _ret);
			}

			LocationModelProvider.prototype.componentWillMount = function componentWillMount() {
				var _props = this.props,
				    locationServiceOrigin = _props.locationServiceOrigin,
				    supportInternationalLocations = _props.supportInternationalLocations,
				    defaultLocation = _props.defaultLocation;

				if (!Model) {
					Model = Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */])({
						config: {
							apiOrigin: locationServiceOrigin,
							international: supportInternationalLocations,
							defaultLocation: defaultLocation
						}
					});
				}
				this.destroy = Model.on.refresh(this.handleLocations);
			};

			LocationModelProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
				var locationServiceOrigin = _ref.locationServiceOrigin;

				if (locationServiceOrigin && this.props.locationServiceOrigin !== locationServiceOrigin) {
					Model.setAPIOrigin(locationServiceOrigin);
				}
			};

			LocationModelProvider.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
				return !__WEBPACK_IMPORTED_MODULE_1__os_shallow_equal___default()(this.props, nextProps) || !__WEBPACK_IMPORTED_MODULE_1__os_shallow_equal___default()(this.state, nextState);
			};

			LocationModelProvider.prototype.componentWillUnmount = function componentWillUnmount() {
				this.destroy && this.destroy();
			};

			LocationModelProvider.prototype.render = function render(props, state) {
				var mappedProps = mapStateToProps(state);
				var mappedActions = mapDispatchToProps(Model, _extends({}, mappedProps, props));
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, _extends({}, mappedProps, mappedActions, props));
			};

			return LocationModelProvider;
		}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]));
	};
}

var LocationProvider = (_dec = Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* configure */])('locationServiceOrigin,supportInternationalLocations,defaultLocation'), _dec(_class2 = function (_Component2) {
	_inherits(LocationProvider, _Component2);

	function LocationProvider() {
		_classCallCheck(this, LocationProvider);

		return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	LocationProvider.prototype.componentWillMount = function componentWillMount() {
		var _props2 = this.props,
		    locationServiceOrigin = _props2.locationServiceOrigin,
		    supportInternationalLocations = _props2.supportInternationalLocations,
		    defaultLocation = _props2.defaultLocation;

		if (!Model) {
			Model = Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */])({
				config: {
					apiOrigin: locationServiceOrigin,
					international: supportInternationalLocations,
					defaultLocation: defaultLocation
				}
			});
		}
	};

	LocationProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
		var locationServiceOrigin = _ref2.locationServiceOrigin;

		if (locationServiceOrigin && this.props.locationServiceOrigin !== locationServiceOrigin) {
			Model.setAPIOrigin(locationServiceOrigin);
		}
	};

	LocationProvider.prototype.render = function render(_ref3, state) {
		var children = _ref3.children,
		    props = _objectWithoutProperties(_ref3, ['children']);

		var child = children && children[0];
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_context_provider__["a" /* default */], { location: Model }, child);
	};

	return LocationProvider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class2);

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_FAVORITES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_RECENTLY_SEARCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCHING_DELAY; });
var MAX_FAVORITES = 5;
var MAX_RECENTLY_SEARCHED = 5;

// The ammount of time to wait after the user has stopped typing input the
// input box before triggering a search request.
var SEARCHING_DELAY = 400;

/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrimaryLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locations_list__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_list_item__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function PrimaryLocation(_ref) {
	var location = _ref.location,
	    onSetCurrent = _ref.onSetCurrent,
	    props = _objectWithoutProperties(_ref, ['location', 'onSetCurrent']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__locations_list__["a" /* default */],
		{ hideHeader: true },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__icon_list_item__["a" /* default */], {
			location: location,
			'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.primaryLocation,
			icon: 'current-location-wire-cube',
			onClickLocation: onSetCurrent
		})
	);
}

/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function IconHeader(_ref) {
	var icon = _ref.icon,
	    children = _ref.children,
	    hidden = _ref.hidden,
	    props = _objectWithoutProperties(_ref, ['icon', 'children', 'hidden']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.header, hidden && __WEBPACK_IMPORTED_MODULE_2__style___default.a.hidden, props.class) }),
		icon && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["i" /* Icon */], { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.icon, name: icon }),
		children
	);
}

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchForLocation */
/* harmony export (immutable) */ __webpack_exports__["a"] = SearchResults;
/* unused harmony export TextInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_header__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon_list_item__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locations_list__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__a11y__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_linkref__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/no-string-refs */











function SearchForLocation(_ref) {
	var value = _ref.value,
	    onInput = _ref.onInput,
	    onKeyDown = _ref.onKeyDown,
	    onKeyUp = _ref.onKeyUp,
	    a11yId = _ref.a11yId,
	    hideHeader = _ref.hideHeader,
	    refocus = _ref.refocus,
	    props = _objectWithoutProperties(_ref, ['value', 'onInput', 'onKeyDown', 'onKeyUp', 'a11yId', 'hideHeader', 'refocus']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		props,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__icon_header__["a" /* default */],
			{ id: a11yId, hidden: hideHeader, icon: 'search-cube' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'search' })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["b" /* Localizer */],
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(TextInput, {
				value: value,
				onKeyDown: onKeyDown,
				onKeyUp: onKeyUp,
				onInput: onInput,
				'aria-describedby': a11yId,
				placeholder: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'inputPlaceholder' }),
				refocus: refocus
			})
		)
	);
}
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_6__a11y__["b" /* default */])('search-for-loc')(SearchForLocation));

function SearchResults(_ref2) {
	var _ref2$locations = _ref2.locations,
	    locations = _ref2$locations === undefined ? [] : _ref2$locations,
	    isFavorite = _ref2.isFavorite,
	    isFavoritesFull = _ref2.isFavoritesFull,
	    onSetCurrent = _ref2.onSetCurrent,
	    onAddFavorite = _ref2.onAddFavorite,
	    props = _objectWithoutProperties(_ref2, ['locations', 'isFavorite', 'isFavoritesFull', 'onSetCurrent', 'onAddFavorite']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_5__locations_list__["a" /* default */],
		_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.searchResults, props.class), live: 'Found ' + locations.length + ' results', 'aria-label': 'Search Results', hideHeader: true }),
		locations.map(function (location) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__icon_list_item__["a" /* default */], {
				location: location,
				icon: 'star-cube',
				'class': __WEBPACK_IMPORTED_MODULE_9_classnames___default()(isFavorite && isFavorite(location) ? __WEBPACK_IMPORTED_MODULE_8__style___default.a.isFavorite : __WEBPACK_IMPORTED_MODULE_8__style___default.a.focusStar, isFavoritesFull && __WEBPACK_IMPORTED_MODULE_8__style___default.a.disabled),
				onClickLocation: onSetCurrent,
				onClickIcon: isFavorite && !isFavorite(location) && onAddFavorite
			});
		})
	);
}

var TextInput = function (_Component) {
	_inherits(TextInput, _Component);

	function TextInput() {
		var _temp, _this, _ret;

		_classCallCheck(this, TextInput);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleInput = function (e) {
			_this.props.onInput && _this.props.onInput(e.target.value);
		}, _this.handleClearInput = function () {
			_this.props.onInput && _this.props.onInput('');
			_this.refs.input && _this.refs.input.focus();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	TextInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {
		var value = _ref3.value,
		    refocus = _ref3.refocus;

		if (this.props.value && !value) {
			this.refs.input && (this.refs.input.value = '');
		}
		if (refocus && this.props.refocus !== refocus) {
			this.refs.input && setTimeout(this.refs.input.focus.bind(this.refs.input));
		}
	};

	TextInput.prototype.render = function render(_ref4) {
		var value = _ref4.value,
		    props = _objectWithoutProperties(_ref4, ['value']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_8__style___default.a.inputContainer },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', _extends({}, props, { onInput: this.handleInput, ref: Object(__WEBPACK_IMPORTED_MODULE_7_linkref__["a" /* default */])(this, 'input') })),
			value && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'button',
				{ 'aria-label': 'Clear search', onClick: this.handleClearInput },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["i" /* Icon */], { name: 'close-cube' })
			)
		);
	};

	return TextInput;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FavoriteLocations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_list_item__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locations_list__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__favorites_counter__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









function FavoriteLocations(_ref) {
	var _ref$locations = _ref.locations,
	    locations = _ref$locations === undefined ? [] : _ref$locations,
	    maxFavorites = _ref.maxFavorites,
	    onDismissFavorite = _ref.onDismissFavorite,
	    onSetCurrent = _ref.onSetCurrent,
	    props = _objectWithoutProperties(_ref, ['locations', 'maxFavorites', 'onDismissFavorite', 'onSetCurrent']);

	var header = [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'favoritesHeader' }), ' ', Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__favorites_counter__["a" /* default */], { numFavorites: locations.length, maxFavorites: maxFavorites })];
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_3__locations_list__["a" /* default */],
		_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style_less___default.a.favorites, props.class), header: header, headerIcon: 'star-cube' }),
		locations.map(function (location) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__icon_list_item__["a" /* default */], {
				location: location,
				'class': __WEBPACK_IMPORTED_MODULE_6__style_less___default.a.focusTrash,
				icon: 'close-cube',
				onClickLocation: onSetCurrent,
				onClickIcon: onDismissFavorite
			});
		})
	);
}

/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecentLocations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_list_item__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locations_list__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RecentLocations = function (_Component) {
	_inherits(RecentLocations, _Component);

	function RecentLocations() {
		_classCallCheck(this, RecentLocations);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	// eslint-disable-line react/prefer-stateless-function
	RecentLocations.prototype.render = function render(_ref) {
		var _ref$locations = _ref.locations,
		    locations = _ref$locations === undefined ? [] : _ref$locations,
		    maxFavorites = _ref.maxFavorites,
		    onAddFavorite = _ref.onAddFavorite,
		    onSetCurrent = _ref.onSetCurrent,
		    isFavoritesFull = _ref.isFavoritesFull,
		    props = _objectWithoutProperties(_ref, ['locations', 'maxFavorites', 'onAddFavorite', 'onSetCurrent', 'isFavoritesFull']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__locations_list__["a" /* default */],
			_extends({}, props, { header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'recentlySearched' }), headerIcon: 'search-cube' }),
			locations.map(function (location, index) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__icon_list_item__["a" /* default */], {
					location: location,
					'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style_less___default.a.focusStar, isFavoritesFull && __WEBPACK_IMPORTED_MODULE_4__style_less___default.a.disabled),
					icon: 'star-cube',
					onClickLocation: onSetCurrent,
					onClickIcon: onAddFavorite
				});
			})
		);
	};

	return RecentLocations;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LoadingText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function LoadingText(_ref) {
	var color = _ref.color,
	    props = _objectWithoutProperties(_ref, ['color']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		_extends({}, props, { 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.loading, __WEBPACK_IMPORTED_MODULE_2__style___default.a[color], props.class) }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'loading' })
	);
}

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TempScaleButton */
/* unused harmony export CurrentTemperature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__weather_svg_icon___ = __webpack_require__(754);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var TempScaleButton = function TempScaleButton(_ref) {
	var children = _ref.children,
	    onClick = _ref.onClick,
	    props = _objectWithoutProperties(_ref, ['children', 'onClick']);

	var action = function action() {
		return onClick && onClick(children[0]);
	};
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': props.class, onClick: action },
		children
	);
};


var isCelsius = function isCelsius(unit) {
	return unit && unit.toUpperCase() === 'C';
};

var CurrentTemperature = function CurrentTemperature(_ref2) {
	var temp = _ref2.temp;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.temp },
		temp,
		'\xB0'
	);
};

var Current = function Current(_ref3) {
	var isCompact = _ref3.isCompact,
	    today = _ref3.today,
	    _ref3$unit = _ref3.unit,
	    unit = _ref3$unit === undefined ? 'F' : _ref3$unit,
	    changeUnit = _ref3.changeUnit;

	if (!today) {
		return;
	}

	/**
  * Render the Current Weather component
  * @param  {boolean} isCompact	Display compact view?
  * @param  {Object} today      Current weather information
  * @param  {string} unit        Temperature units in use 'C' or 'F'
  * @param  {Function} changeUnit} Callback for updating the unit type used
  * @return {string}             The rendered component
  */
	var currentTemp = isCelsius(unit) ? today.currentTempCels : today.currentTemp;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.current, isCompact && __WEBPACK_IMPORTED_MODULE_2__style___default.a.compact) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.temperature },
			isCompact && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.icon },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__weather_svg_icon___["a" /* default */], { name: today.weatherIconCode, 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.conditionIcon })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CurrentTemperature, { temp: currentTemp }),
			!isCompact && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.degreePicker },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					TempScaleButton,
					{
						'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.fahrenheit, !isCelsius(unit) && __WEBPACK_IMPORTED_MODULE_2__style___default.a.active),
						onClick: changeUnit
					},
					'F'
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					TempScaleButton,
					{
						'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.celsius, isCelsius(unit) && __WEBPACK_IMPORTED_MODULE_2__style___default.a.active),
						onClick: changeUnit
					},
					'C'
				)
			)
		),
		!isCompact && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.icon },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__weather_svg_icon___["a" /* default */], { name: today.weatherIconCode, 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.conditionIcon) })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'p',
					null,
					today.conditionDescription
				)
			)
		)
	);
};
/* harmony default export */ __webpack_exports__["a"] = (Current);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_split_point__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_weather_svg_icon_weather_svg_icon__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_weather_svg_icon_weather_svg_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_weather_svg_icon_weather_svg_icon__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__os_split_point__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_weather_svg_icon_weather_svg_icon___default.a));

/***/ })

});


// WEBPACK FOOTER //
// widgets/weather.6259b016.chunk.js